"use strict";
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createAddress(containerEl, deps) {
                var formDeps = deps.formDeps, getAddress = deps.getAddress, isNew = deps.isNew, disableDefaultAddress = deps.disableDefaultAddress, countryChangeEnabled = deps.countryChangeEnabled;
                var popupEl = eXpress.html.querySelector(document, '.p-my-account-address', true);
                var popupFormEl = eXpress.html.querySelector(document, '.technical-address-form', true);
                var buttonContainerEl = eXpress.html.querySelector(popupEl, '.technical-address-button-container', true);
                var saveDeliveryAddressButtonEl = eXpress.html.querySelector(buttonContainerEl, '.technical-save-address-button', true);
                var addressForm = checkout.createPersonalDataForm(eXpress.html.querySelector(containerEl, '.technical-address-form', true), {
                    onSubmit: formDeps.onSubmit,
                    getZipCodeDefinitionAsync: formDeps.getZipCodeDefinitionAsync,
                    getCitiesForCountryCodeAndSearchTerm: formDeps.getCitiesForCountryCodeAndSearchTerm,
                    getGetCitiesByZipCode: formDeps.getGetCitiesByZipCode,
                    alternativeSubmitButtonEl: saveDeliveryAddressButtonEl
                });
                if (!isNew) {
                    eXpress.utils.showLoadingDialog(getAddress().then(function (res) { return addressForm.fillFormData(res, disableDefaultAddress, countryChangeEnabled); }));
                }
                var isCompanyEl = eXpress.html.querySelector(popupEl, '.technical-company', false);
                var isCompany = isCompanyEl && isCompanyEl.checked;
                var overrideDefaultRegions = popupFormEl.dataset.defaultRegions || '';
                addressForm.updateCountry(containerEl.dataset.defaultRegion, isCompany, false, overrideDefaultRegions);
                return {
                    setErrors: addressForm.setErrors,
                    dispose: addressForm.dispose,
                };
            }
            checkout.createAddress = createAddress;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createAdyenDropIn(containerEl, deps) {
                return __awaiter(this, void 0, void 0, function () {
                    var locale, clientKey, countryCode, currency, amount, refreshMiniBasket, environment, enableStoreDetails, placeOrderContainerEl, resetButtonEl, loadingEl, obKlarna, eventDisposables, _a, AdyenCheckout, Dropin, adyenDropInComponent, adyenCheckoutObject, configuration, dropInOpts, selectedPaymentBrand, forceNewOrder, reason, selectedClass, nextSelectedClass, paymentMethodClass, buttonSelector, paymentMethodSelector, paymentMethodHeaderTitleSelector, getTestOrderOptionValue, getPaymentMethods, validate, initiatePayment, submitAdditionalDetails, placeOfflineOrder, newsletterEl, personalMessageEl, testOrderOptionEl, updateCartHandlingCost, disableStoredPaymentMethod, fetchRecaptchaToken, recaptchaEnabled, onBankTransferSubmit, deselectPaymentMethod, onBankTransferClick, injectCustomInvoiceMethod, injectKlarnaAdditionalFeeMessage, injectSwishMessage, toggleSelectedPaymentMethodState, toggleDisableAllButtonStates, toggleDisableButtonState, injectExtraPaymentMethods, onBrand, init, reset;
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                locale = containerEl.dataset.locale || "";
                                clientKey = containerEl.dataset.clientkey || "";
                                countryCode = containerEl.dataset.countrycode || "";
                                currency = containerEl.dataset.currency || "";
                                amount = containerEl.dataset.amount || "";
                                refreshMiniBasket = containerEl.dataset.refreshminibasket === "true";
                                environment = containerEl.dataset.isproduction === "true" ? "live" : "test";
                                enableStoreDetails = containerEl.dataset.enablestoredetails === "true";
                                placeOrderContainerEl = eXpress.html.querySelector(document, ".technical-place-order-checkout-step", true);
                                resetButtonEl = eXpress.html.querySelector(placeOrderContainerEl, ".technical-reset", true);
                                loadingEl = eXpress.html.querySelector(document, '.adyen-loading', false);
                                obKlarna = undefined;
                                eventDisposables = eXpress.utils.compositeDisposable([]);
                                _a = window.AdyenWeb, AdyenCheckout = _a.AdyenCheckout, Dropin = _a.Dropin;
                                forceNewOrder = false;
                                reason = eXpress.utils.getParameter('reason', document.location.href, false);
                                selectedClass = "adyen-checkout__payment-method--selected";
                                nextSelectedClass = "adyen-checkout__payment-method--next-selected";
                                paymentMethodClass = "adyen-checkout__payment-method";
                                buttonSelector = ".adyen-checkout__button";
                                paymentMethodSelector = ".adyen-checkout__payment-method";
                                paymentMethodHeaderTitleSelector = ".adyen-checkout__payment-method__header__title";
                                if (reason && reason.toLowerCase() === 'refused') {
                                    forceNewOrder = true;
                                }
                                getTestOrderOptionValue = deps.getTestOrderOptionValue, getPaymentMethods = deps.getPaymentMethods, validate = deps.validate, initiatePayment = deps.initiatePayment, submitAdditionalDetails = deps.submitAdditionalDetails, placeOfflineOrder = deps.placeOfflineOrder, newsletterEl = deps.newsletterEl, personalMessageEl = deps.personalMessageEl, testOrderOptionEl = deps.testOrderOptionEl, updateCartHandlingCost = deps.updateCartHandlingCost, disableStoredPaymentMethod = deps.disableStoredPaymentMethod, fetchRecaptchaToken = deps.fetchRecaptchaToken, recaptchaEnabled = deps.recaptchaEnabled;
                                onBankTransferSubmit = function (e) {
                                    e.preventDefault();
                                    if (validate()) {
                                        toggleDisableAllButtonStates(true);
                                        toggleDisableButtonState(resetButtonEl, true, false);
                                        var bankTransferEl = eXpress.html.querySelector(containerEl, '.technical-bank-transfer', true);
                                        var printPaymentFormEl = eXpress.html.querySelector(bankTransferEl, "#printPaymentForm", false);
                                        placeOfflineOrder(newsletterEl.checked, personalMessageEl.checked, printPaymentFormEl && printPaymentFormEl.checked || false, selectedPaymentBrand, getTestOrderOptionValue(testOrderOptionEl));
                                    }
                                };
                                deselectPaymentMethod = function () {
                                    var bankTransferEl = eXpress.html.querySelector(containerEl, '.technical-bank-transfer', false);
                                    if (bankTransferEl) {
                                        bankTransferEl.classList.remove(selectedClass);
                                        bankTransferEl.classList.remove(nextSelectedClass);
                                        var paymentHeaderTitle = eXpress.html.querySelector(bankTransferEl, paymentMethodHeaderTitleSelector, true);
                                        paymentHeaderTitle.setAttribute("aria-checked", "false");
                                        paymentHeaderTitle.setAttribute("aria-expanded", "false");
                                        var paymentMethodDetailsEl = eXpress.html.querySelector(bankTransferEl, '.adyen-checkout-pm-details-wrapper', true);
                                        paymentMethodDetailsEl.setAttribute("aria-hidden", "true");
                                    }
                                };
                                onBankTransferClick = function (ev) {
                                    selectedPaymentBrand = "banktransfer";
                                    toggleDisableAllButtonStates(false);
                                    toggleDisableButtonState(resetButtonEl, false, false);
                                    refreshMiniBasket && updateCartHandlingCost(0, 1);
                                    var currentEl = ev.currentTarget;
                                    var bankTransferEl = eXpress.html.getParentOrSelfWithClassName(currentEl, "technical-bank-transfer");
                                    if (bankTransferEl) {
                                        if (eXpress.html.hasClass(bankTransferEl, selectedClass))
                                            return;
                                        adyenDropInComponent.closeActivePaymentMethod();
                                        var paymentHeaderTitle = eXpress.html.querySelector(bankTransferEl, paymentMethodHeaderTitleSelector, true);
                                        paymentHeaderTitle.setAttribute("aria-checked", "true");
                                        paymentHeaderTitle.setAttribute("aria-expanded", "true");
                                        var paymentMethodDetailsEl = eXpress.html.querySelector(bankTransferEl, '.adyen-checkout-pm-details-wrapper', true);
                                        paymentMethodDetailsEl.setAttribute("aria-hidden", "false");
                                        bankTransferEl.classList.add(selectedClass);
                                        var previousPaymentMethodLi = bankTransferEl.previousElementSibling;
                                        if (previousPaymentMethodLi) {
                                            previousPaymentMethodLi = previousPaymentMethodLi.previousElementSibling;
                                            previousPaymentMethodLi && previousPaymentMethodLi.classList.add(nextSelectedClass);
                                        }
                                    }
                                };
                                injectCustomInvoiceMethod = function (templatesEl) {
                                    var template = templatesEl.children[0];
                                    var divEl = document.createElement("div");
                                    template.classList.forEach(function (c) { divEl.classList.add(c); });
                                    divEl.classList.add("technical-bank-transfer");
                                    divEl.innerHTML = template.innerHTML;
                                    if (containerEl) {
                                        var paymentList = eXpress.html.querySelector(containerEl, ".adyen-checkout__payment-methods-list--otherPayments", false);
                                        if (paymentList) {
                                            var existingListEl = eXpress.html.querySelector(paymentList, ".technical-bank-transfer", false);
                                            if (!existingListEl) {
                                                paymentList.insertAdjacentElement("beforeend", divEl);
                                                divEl = eXpress.html.querySelector(paymentList, ".technical-bank-transfer", true);
                                                var bankTransferTitleEl = eXpress.html.querySelector(divEl, ".adyen-checkout__payment-method__header", true);
                                                var bankTransferButtonEl = eXpress.html.querySelector(divEl, ".technical-submit-bank-transfer", true);
                                                if (eventDisposables && eventDisposables.add) {
                                                    eventDisposables.add([
                                                        eXpress.html.addEventListener(bankTransferTitleEl, "click", onBankTransferClick),
                                                        eXpress.html.addEventListener(bankTransferButtonEl, "click", onBankTransferSubmit)
                                                    ]);
                                                }
                                            }
                                        }
                                    }
                                };
                                injectKlarnaAdditionalFeeMessage = function (listEl, description, feeMessage) {
                                    var contentEl = eXpress.html.querySelector(listEl, ".adyen-checkout__payment-method__details__content", false);
                                    if (contentEl) {
                                        var buttonEl = eXpress.html.querySelector(contentEl, buttonSelector, false);
                                        if (buttonEl) {
                                            var remarkEl = eXpress.html.querySelector(contentEl, ".m-adyen-drop-in__remarks", false);
                                            if (!remarkEl && obKlarna) {
                                                obKlarna.disconnect();
                                                var remarksDiv = document.createElement("div");
                                                remarksDiv.classList.add("m-adyen-drop-in__remarks");
                                                var feeMessageEl = document.createElement("p");
                                                feeMessageEl.innerHTML = feeMessage;
                                                feeMessageEl.classList.add("a-typography--remarks");
                                                var descriptionEl = document.createElement("p");
                                                descriptionEl.innerHTML = description;
                                                descriptionEl.classList.add("m-adyen-drop-in__description");
                                                remarksDiv.append(descriptionEl);
                                                remarksDiv.append(feeMessageEl);
                                                if (contentEl.parentElement)
                                                    contentEl.parentElement.insertBefore(remarksDiv, contentEl);
                                                buttonEl.classList.remove("adyen-checkout__button--standalone");
                                            }
                                        }
                                    }
                                };
                                injectSwishMessage = function (message) {
                                    var swishDropin = eXpress.html.querySelector(document, ".technical-dropin-container");
                                    if (swishDropin) {
                                        var msgEl = eXpress.html.querySelector(swishDropin, ".adyen-checkout__qr-loader__subtitle", false);
                                        if (msgEl) {
                                            var remarksDiv = document.createElement("div");
                                            remarksDiv.classList.add("m-adyen-drop-in__remarks");
                                            var messageEl = document.createElement("p");
                                            messageEl.innerHTML = message;
                                            messageEl.classList.add("a-typography--remarks");
                                            remarksDiv.append(messageEl);
                                            if (msgEl.parentElement)
                                                msgEl.parentElement.insertBefore(remarksDiv, msgEl);
                                        }
                                        else
                                            setTimeout(function () { injectSwishMessage(message); }, 100);
                                    }
                                    else
                                        setTimeout(function () { injectSwishMessage(message); }, 100);
                                };
                                toggleSelectedPaymentMethodState = function (el, select) {
                                    if (el)
                                        el.classList.toggle(selectedClass, select);
                                };
                                toggleDisableAllButtonStates = function (disable) {
                                    var buttonEls = eXpress.html.querySelectorAll(document, buttonSelector);
                                    buttonEls.forEach(function (buttonEl) {
                                        toggleDisableButtonState(buttonEl, disable);
                                    });
                                    var els = eXpress.html.querySelectorAll(document, paymentMethodSelector);
                                    els.forEach(function (el) { toggleSelectedPaymentMethodState(el, false); });
                                };
                                toggleDisableButtonState = function (buttonEl, disable, changeAttribute) {
                                    if (changeAttribute === void 0) { changeAttribute = true; }
                                    if (disable) {
                                        buttonEl.classList.add("a-button--disabled");
                                        if (changeAttribute)
                                            buttonEl.setAttribute("disabled", "true");
                                    }
                                    else {
                                        buttonEl.classList.remove("a-button--disabled");
                                        if (changeAttribute)
                                            buttonEl.removeAttribute("disabled");
                                    }
                                };
                                injectExtraPaymentMethods = function () {
                                    if (placeOrderContainerEl) {
                                        var templatesEl = eXpress.html.querySelector(placeOrderContainerEl, ".technical-banktransfer-templates", false);
                                        if (templatesEl)
                                            injectCustomInvoiceMethod(templatesEl);
                                    }
                                };
                                onBrand = function (callBack) {
                                    if (callBack && callBack.brand) {
                                        selectedPaymentBrand = callBack.brand;
                                    }
                                };
                                init = function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _this = this;
                                    return __generator(this, function (_a) {
                                        getPaymentMethods().then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                            var translations;
                                            var _this = this;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        translations = {};
                                                        if (loadingEl)
                                                            eXpress.html.hide(loadingEl);
                                                        if (res.translations)
                                                            translations = res.translations;
                                                        if (!res.redirectUrl) return [3, 1];
                                                        window.location.href = res.redirectUrl;
                                                        return [3, 3];
                                                    case 1:
                                                        configuration = {
                                                            paymentMethodsResponse: res,
                                                            clientKey: clientKey,
                                                            locale: locale,
                                                            translations: translations,
                                                            environment: environment,
                                                            showPayButton: true,
                                                            countryCode: countryCode,
                                                            onError: function (error, component) {
                                                                if (error.name !== 'CANCEL')
                                                                    return;
                                                                adyenDropInComponent.closeActivePaymentMethod();
                                                                deselectPaymentMethod();
                                                            },
                                                            onPaymentMethodsRequest: function (data, actions) { return __awaiter(_this, void 0, void 0, function () {
                                                                var paymentMethods;
                                                                return __generator(this, function (_a) {
                                                                    paymentMethods = getPaymentMethods();
                                                                    actions.resolve(paymentMethods);
                                                                    return [2];
                                                                });
                                                            }); },
                                                            onSubmit: function (state, component, actions) {
                                                                var submit = function (token) {
                                                                    var swishAppNotAvailable = containerEl.dataset.swishappnotavailable || "";
                                                                    if (state.isValid && validate()) {
                                                                        toggleDisableAllButtonStates(true);
                                                                        var data = {
                                                                            Newsletter: newsletterEl.checked,
                                                                            PersonalMessage: personalMessageEl.checked,
                                                                            ForceNewOrder: forceNewOrder,
                                                                            PaymentRequest: state.data,
                                                                            Token: token || '',
                                                                            TestOrderOption: getTestOrderOptionValue(testOrderOptionEl),
                                                                            PaymentBrand: state.data.paymentMethod && state.data.paymentMethod.brand ? state.data.paymentMethod.brand : selectedPaymentBrand,
                                                                            PaymentName: state.data.paymentMethod.storedPaymentMethodId && state.data.paymentMethod.storedPaymentMethodId !== ''
                                                                                ? 'storedcard'
                                                                                : res.paymentMethods && res.paymentMethods.find(function (p) { return p.type === (state.data.paymentMethod.type === "scheme" && selectedPaymentBrand === "bcmc"
                                                                                    ? selectedPaymentBrand
                                                                                    : state.data.paymentMethod.type); }).name || '',
                                                                            SupportedShopperInteractions: res.storedPaymentMethods && state.data.paymentMethod.storedPaymentMethodId && state.data.paymentMethod.storedPaymentMethodId !== ''
                                                                                ? res.storedPaymentMethods.find(function (s) { return s.id === state.data.paymentMethod.storedPaymentMethodId; }).supportedShopperInteractions
                                                                                : []
                                                                        };
                                                                        var liElSwish = eXpress.html.querySelector(document, ".adyen-checkout__payment-method--swish");
                                                                        if (liElSwish)
                                                                            injectSwishMessage(swishAppNotAvailable);
                                                                        initiatePayment(data, component, actions);
                                                                    }
                                                                    else {
                                                                        component.setStatus('ready');
                                                                        return false;
                                                                    }
                                                                };
                                                                if (recaptchaEnabled) {
                                                                    fetchRecaptchaToken().then(function (token) {
                                                                        submit(token);
                                                                    });
                                                                }
                                                                else {
                                                                    submit();
                                                                }
                                                            },
                                                            onAdditionalDetails: function (state, component, actions) {
                                                                submitAdditionalDetails(state.data, component, actions);
                                                            }
                                                        };
                                                        dropInOpts = {
                                                            openFirstPaymentMethod: false,
                                                            openFirstStoredPaymentMethod: false,
                                                            showStoredPaymentMethods: true,
                                                            showRemovePaymentMethodButton: true,
                                                            paymentMethodsConfiguration: {
                                                                bcmc: {
                                                                    hasHolderName: true,
                                                                    enableStoreDetails: enableStoreDetails,
                                                                    holderNameRequired: true,
                                                                    onBrand: onBrand
                                                                },
                                                                card: {
                                                                    hasHolderName: true,
                                                                    enableStoreDetails: enableStoreDetails,
                                                                    holderNameRequired: true,
                                                                    hideCVC: false,
                                                                    onBrand: onBrand
                                                                },
                                                                applepay: {
                                                                    amount: {
                                                                        currency: currency,
                                                                        value: amount,
                                                                        countryCode: 'BE'
                                                                    },
                                                                    onClick: function (resolve) {
                                                                        validate();
                                                                        return resolve(true);
                                                                    }
                                                                },
                                                                paypal: {
                                                                    environment: environment,
                                                                    countryCode: countryCode,
                                                                    amount: {
                                                                        currency: currency,
                                                                        value: amount
                                                                    },
                                                                    onClick: function () {
                                                                        return validate();
                                                                    }
                                                                },
                                                                bcmc_mobile: {
                                                                    icon: eXpress.utils.resolveVersionedUrlCdn('/appdata/', 'img/payconiq.png')
                                                                },
                                                                threeDS2: { challengeWindowSize: '05' }
                                                            },
                                                            onSelect: function (component) {
                                                                validate();
                                                                selectedPaymentBrand = component.props.type;
                                                                toggleDisableButtonState(resetButtonEl, false, false);
                                                                toggleDisableAllButtonStates(false);
                                                                var bankTransferEl = eXpress.html.querySelector(containerEl, ".technical-bank-transfer", false);
                                                                bankTransferEl && deselectPaymentMethod();
                                                                var message = containerEl.dataset.klarnamessage || "";
                                                                var description = containerEl.dataset.klarnadescription || "";
                                                                if (component._id) {
                                                                    var currentEl_1 = eXpress.html.querySelector(containerEl, "#container-" + component._id, true);
                                                                    var obOptionalCvc = new MutationObserver(function (mutations) {
                                                                        mutations.forEach(function (mutation) {
                                                                            if (!mutation.addedNodes)
                                                                                return;
                                                                            var optionalCvcEl = eXpress.html.querySelector(currentEl_1, ".adyen-checkout__field__cvc--optional", false);
                                                                            if (optionalCvcEl)
                                                                                optionalCvcEl.style.display = "none";
                                                                        });
                                                                    });
                                                                    obOptionalCvc.observe(currentEl_1, { childList: true, subtree: true, attributes: false, characterData: false });
                                                                    if (placeOrderContainerEl && message && description) {
                                                                        var liEl_1 = eXpress.html.getParentWithClassName(currentEl_1, "adyen-checkout__payment-method--klarna");
                                                                        if (liEl_1) {
                                                                            refreshMiniBasket && updateCartHandlingCost(1, 1);
                                                                            if (obKlarna === undefined) {
                                                                                obKlarna = new MutationObserver(function (mutations) {
                                                                                    mutations.forEach(function (mutation) {
                                                                                        if (!mutation.addedNodes)
                                                                                            return;
                                                                                        injectKlarnaAdditionalFeeMessage(liEl_1, description, message);
                                                                                    });
                                                                                });
                                                                                obKlarna.observe(liEl_1, { childList: true, subtree: true, attributes: false, characterData: false });
                                                                            }
                                                                        }
                                                                        else {
                                                                            var noKlarnaLiEl = eXpress.html.getParentWithClassName(currentEl_1, paymentMethodClass);
                                                                            toggleSelectedPaymentMethodState(noKlarnaLiEl, true);
                                                                            refreshMiniBasket && updateCartHandlingCost(1, 3);
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            onDisableStoredPaymentMethod: function (storedPaymentMethodId, resolve, reject) {
                                                                disableStoredPaymentMethod({ RecurringDetailReference: storedPaymentMethodId }).then(function (res) {
                                                                    if (res.redirectUrl)
                                                                        window.location.href = res.redirectUrl;
                                                                    if (res.success) {
                                                                        resolve();
                                                                        toggleDisableButtonState(resetButtonEl, true, false);
                                                                    }
                                                                    else
                                                                        reject();
                                                                });
                                                            },
                                                            onReady: function () { injectExtraPaymentMethods(); }
                                                        };
                                                        return [4, AdyenCheckout(configuration)];
                                                    case 2:
                                                        adyenCheckoutObject = _a.sent();
                                                        adyenDropInComponent = new Dropin(adyenCheckoutObject, dropInOpts).mount(containerEl);
                                                        _a.label = 3;
                                                    case 3: return [2];
                                                }
                                            });
                                        }); });
                                        eXpress.html.addEventListener(resetButtonEl, 'click', function (ev) {
                                            ev.preventDefault();
                                            reset();
                                        });
                                        return [2];
                                    });
                                }); };
                                reset = function () {
                                    if (resetButtonEl && !resetButtonEl.classList.contains("a-button--disabled")) {
                                        adyenCheckoutObject.remove(adyenDropInComponent);
                                        eXpress.utils.showLoadingDialog(getPaymentMethods().then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                adyenCheckoutObject.setOptions({
                                                    paymentMethodsResponse: res
                                                });
                                                adyenDropInComponent = new Dropin(adyenCheckoutObject, dropInOpts).mount(containerEl);
                                                refreshMiniBasket && updateCartHandlingCost(1, 3);
                                                toggleDisableButtonState(resetButtonEl, true, false);
                                                containerEl.scrollIntoView();
                                                return [2];
                                            });
                                        }); }));
                                    }
                                };
                                return [4, init()];
                            case 1:
                                _b.sent();
                                return [2, {
                                        dispose: function () { obKlarna && obKlarna.disconnect(); eventDisposables && eventDisposables.dispose(); },
                                        reset: reset
                                    }];
                        }
                    });
                });
            }
            checkout.createAdyenDropIn = createAdyenDropIn;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createConfirmation(containerEl, deps) {
                var beaContainerEl = eXpress.html.querySelector(containerEl, ".technical-bea-container", false);
                var beaSubmitButtonEl = eXpress.html.querySelector(containerEl, ".technical-bea-submit", false);
                var beaAccnrInputContainerEl = eXpress.html.querySelector(containerEl, ".technical-beaaccnr-input-container", false);
                var loginContainer = eXpress.html.querySelector(document, ".technical-login-container", false);
                var loginForm = eXpress.html.querySelector(document, ".technical-login-form", false);
                var loginAuthenticationLinks = eXpress.html.querySelector(document, ".technical-login", false);
                var loginFormComponent;
                var registerContainer = eXpress.html.querySelector(document, ".technical-register-container", false);
                var registerForm = eXpress.html.querySelector(document, ".technical-register-form", false);
                var eventDisposables = eXpress.utils.compositeDisposable([]);
                var doMondoCall = deps.doMondoCall, showLoginPopup = deps.showLoginPopup;
                var orderId;
                var beaAccnr;
                var onBeaSubmit = function (e) {
                    e.preventDefault();
                    if (beaContainerEl && beaAccnrInputContainerEl) {
                        beaAccnrInputContainerEl.classList.remove("a-form-input--error");
                        beaContainerEl.classList.remove("m-bea-form--success");
                        var beaAccnrEl = eXpress.html.querySelector(beaAccnrInputContainerEl, ".technical-beaaccnr", false);
                        if (beaAccnrEl && beaAccnrEl.value) {
                            beaAccnr = beaAccnrEl.value;
                            doMondoCall(orderId, beaAccnr).then(function (res) {
                                if (res.success === 'False')
                                    beaAccnrInputContainerEl.classList.add("a-form-input--error");
                                else {
                                    beaContainerEl.classList.add("m-bea-form--success");
                                    beaContainerEl.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            });
                        }
                        else {
                            beaAccnrInputContainerEl.classList.add("a-form-input--error");
                        }
                    }
                };
                var loggedInWithAccount = function () {
                    document.location.reload();
                };
                var init = function () {
                    if (beaSubmitButtonEl && eventDisposables && eventDisposables.add) {
                        orderId = beaSubmitButtonEl.getAttribute("data-orderid") || '';
                        eventDisposables.add([
                            eXpress.html.addEventListener(beaSubmitButtonEl, 'click', onBeaSubmit)
                        ]);
                    }
                    if (loginContainer && loginForm) {
                        loginFormComponent = eXpress.components.main.createStandardInlineLogin(loginContainer, loginForm, {
                            showForgotPasswordPopup: deps.showForgotPasswordPopup,
                            popups: deps.popups
                        }, null, loggedInWithAccount);
                        loginFormComponent.hideCloseButton();
                        loginFormComponent.disableInput("email");
                    }
                    if (registerContainer && registerForm) {
                        eXpress.components.main.createStandardInlineRegister(registerContainer, registerForm, {
                            showForgotPasswordPopup: deps.showForgotPasswordPopup,
                            popups: deps.popups
                        }, null, loggedInWithAccount);
                    }
                    loginAuthenticationLinks && loginAuthenticationLinks.addEventListener('click', function (_) { return showLoginPopup(loginAuthenticationLinks.dataset.mode, loginAuthenticationLinks.dataset.email); });
                };
                init();
                return {
                    dispose: function () { eventDisposables && eventDisposables.dispose(); },
                    loginForm: loginFormComponent
                };
            }
            checkout.createConfirmation = createConfirmation;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createDeliveryAddress(containerEl, deps) {
                var formDeps = deps.formDeps, getAddress = deps.getAddress, isNew = deps.isNew, disableDefaultAddress = deps.disableDefaultAddress, countryChangeEnabled = deps.countryChangeEnabled;
                var popupEl = eXpress.html.querySelector(document, '.p-delivery-address', true);
                var buttonContainerEl = eXpress.html.querySelector(popupEl, '.technical-delivery-address-button-container', true);
                var saveDeliveryAddressButtonEl = eXpress.html.querySelector(buttonContainerEl, '.technical-save-delivery-address-button', true);
                var deliveryAddressForm = checkout.createPersonalDataForm(eXpress.html.querySelector(containerEl, '.technical-delivery-address-form', true), {
                    onSubmit: formDeps.onSubmit,
                    getZipCodeDefinitionAsync: formDeps.getZipCodeDefinitionAsync,
                    getCitiesForCountryCodeAndSearchTerm: formDeps.getCitiesForCountryCodeAndSearchTerm,
                    getGetCitiesByZipCode: formDeps.getGetCitiesByZipCode,
                    alternativeSubmitButtonEl: saveDeliveryAddressButtonEl
                });
                if (!isNew) {
                    eXpress.utils.showLoadingDialog(getAddress()
                        .then(function (res) { return deliveryAddressForm.fillFormData(res, disableDefaultAddress, countryChangeEnabled); }));
                }
                else {
                    deliveryAddressForm.updateCountry(containerEl.dataset.defaultRegion, false);
                }
                return {
                    setErrors: deliveryAddressForm.setErrors,
                    dispose: deliveryAddressForm.dispose,
                };
            }
            checkout.createDeliveryAddress = createDeliveryAddress;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createDeliveryInfo(deliveryFormEl, rightColumnEl, gtmData, deps) {
                var blocked = false;
                var deliveryAddressPickerPopup = deps.deliveryAddressPickerPopup, changeMiniBasketServerSide = deps.changeMiniBasketServerSide, getLabelAsync = deps.getLabelAsync, pickupPickerPopup = deps.pickupPickerPopup, updateDeliveryChoices = deps.updateDeliveryChoices, pickCorrectAddressPopup = deps.pickCorrectAddressPopup, submitPartialDeliveryAddress = deps.submitPartialDeliveryAddress, hideTopMessage = deps.hideTopMessage, showTopMessage = deps.showTopMessage, iconsPopup = deps.iconsPopup, logError = deps.logError;
                var deliveryAddressPickerButtonEl = eXpress.html.querySelector(deliveryFormEl, ".technical-delivery-address-picker-button-homedelivery");
                var pickupPickerButtonEl = eXpress.html.querySelector(deliveryFormEl, ".technical-delivery-address-picker-button-pickupdelivery");
                var nextButtons = eXpress.html.querySelectorAll(rightColumnEl, ".technical-checkout-step-confirm-button");
                var groups = eXpress.html.querySelectorAll(deliveryFormEl, ".technical-method-group");
                var radios = eXpress.html.querySelectorAll(deliveryFormEl, ".technical-delivery-time-picker-radio");
                var debugSectionEl = eXpress.html.querySelector(deliveryFormEl, "#debugSection");
                var prettyButtonEl = eXpress.html.querySelector(deliveryFormEl, "#pretty");
                var thumbInfoEls = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-time-picker-thumb-info');
                var goToDeliveryMethodsLabels = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-method-group-gotodatepicker');
                var iconsEls = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-icons-popup');
                var addressPickerClass = '.technical-method-adress-picker';
                var resetSelectedRadioButtonAfterSlideChange = true;
                var activeClass = "m-delivery-time-selector__option--selected";
                var disabledClass = "m-delivery-time-selector__option--disabled";
                var currentVisibleItems;
                var changeHomeDeliveryAddress = function (newAddress1, newAddress2, jsonAddress) {
                    var homeDeliveryAddress1El = eXpress.html.querySelector(deliveryFormEl, '.technical-home-address1', false);
                    var homeDeliveryAddress2El = eXpress.html.querySelector(deliveryFormEl, '.technical-home-address2', false);
                    selectHomeDeliveryOption();
                    var radio = eXpress.html.querySelector(deliveryFormEl, 'input[type="radio"][value*="home"]');
                    if (radio)
                        radio.dataset.currentAddress = jsonAddress;
                    if (homeDeliveryAddress1El)
                        homeDeliveryAddress1El.innerHTML = newAddress1;
                    if (homeDeliveryAddress2El)
                        homeDeliveryAddress2El.innerHTML = newAddress2;
                };
                var selectHomeDeliveryOption = function () {
                    var radio = eXpress.html.querySelector(deliveryFormEl, 'input[type="radio"][value*="home"]');
                    if (radio) {
                        if (radio.dataset.forceaddresspopup === "true")
                            radio.dataset.forceaddresspopup = 'false';
                        if (!radio.checked)
                            radio.click();
                    }
                };
                var getSelectedMethodGroup = function () {
                    var selectedMethod = eXpress.html.querySelector(deliveryFormEl, 'input[name="methodGroup"]:checked');
                    if (!selectedMethod)
                        return undefined;
                    var selectedMethodGroupStr = selectedMethod.value;
                    if (!selectedMethodGroupStr)
                        return undefined;
                    return selectedMethodGroupStr;
                };
                var getDeliveryChoicesItemGroup = function (selectedMethodGroupStr) {
                    var items = [];
                    var radios = eXpress.html.querySelectorAll(deliveryFormEl, 'input[name^="' + selectedMethodGroupStr + '-"]:checked');
                    radios.forEach(function (r) {
                        var ids = r.dataset.cartitemids;
                        if (ids)
                            items.push({
                                SelectedMethod: r.value,
                                CartItemIds: ids.split('|'),
                                ProductionSchedule: parseInt(r.dataset.prodsched || "2", 10)
                            });
                    });
                    return items;
                };
                var getDeliveryChoicesItemGroups = function (selectedMethodGroupStr, withDefaults) {
                    if (withDefaults === void 0) { withDefaults = false; }
                    var items = [];
                    var radios = eXpress.html.querySelectorAll(deliveryFormEl, 'input[name^="' + selectedMethodGroupStr + '-"]');
                    var groups = radios.map(function (r) { return r.name; }).filter(function (value, index, self) { return self.indexOf(value) === index; });
                    groups.forEach(function (g) {
                        var radiosInGroup = radios.filter(function (r) { return r.name == g; });
                        var selected = radiosInGroup.find(function (r) { return r.checked; });
                        if (!selected && withDefaults) {
                            selected = radiosInGroup.find(function (r) { return !r.checked && r.dataset.default === 'true'; });
                        }
                        if (selected) {
                            var ids = selected.dataset.cartitemids;
                            if (ids)
                                items.push({
                                    SelectedMethod: selected.value,
                                    CartItemIds: ids.split('|'),
                                    ProductionSchedule: parseInt(selected.dataset.prodsched || "2", 10)
                                });
                        }
                    });
                    return items;
                };
                var calculateSelectedShipping = function () {
                    var selectedMethodGroupStr = getSelectedMethodGroup();
                    if (!selectedMethodGroupStr) {
                        document.location.reload();
                        return;
                    }
                    var items = getDeliveryChoicesItemGroups(selectedMethodGroupStr);
                    if (!items || items.length === 0)
                        return;
                    var postalInformationEl = eXpress.html.querySelector(deliveryFormEl, '#postal_information_personal_data', false);
                    var postalInformation = '';
                    if (postalInformationEl)
                        postalInformation = postalInformationEl.value;
                    changeMiniBasketServerSide(selectedMethodGroupStr, items, postalInformation);
                };
                var onWindowResize = function () {
                    setRightColTopPosition(rightColumnEl);
                    rightColumnEl.style.transform = "0";
                };
                var setRightColTopPosition = function (div) {
                    if (window.innerHeight < div.clientHeight)
                        div.style.top = (window.innerHeight - div.clientHeight - 20) + 'px';
                    else
                        div.style.top = '0px';
                };
                var prettyFi = function () {
                    var textEl = eXpress.html.querySelector(debugSectionEl, "textarea");
                    if (textEl) {
                        var ugly = textEl.value;
                        var json = JSON.parse(ugly);
                        textEl.value = JSON.stringify(json, undefined, 4);
                    }
                };
                var onNextButtonClick = function (event) {
                    if (blocked)
                        return;
                    var buttonEl = (event.currentTarget || event.srcElement);
                    var button = components.main.createButton(buttonEl);
                    button.disable();
                    if (eXpress.html.querySelectorAll(deliveryFormEl, 'input[name="methodGroup"]:checked').length === 0) {
                        getLabelAsync("Label.Delivery.DeliveryMethod.NoDeliveryMethodSelected").then(function (res) { return showTopMessage(components.main.PageLogStyle.Error, res); });
                        button.enable();
                        return;
                    }
                    var selectedMethod = eXpress.html.querySelector(deliveryFormEl, 'input[name="methodGroup"]:checked');
                    if (!selectedMethod) {
                        document.location.reload();
                        return;
                    }
                    var selectedMethodGroupStr = selectedMethod.value;
                    if (!selectedMethodGroupStr) {
                        document.location.reload();
                        return;
                    }
                    if (eXpress.html.querySelectorAll(deliveryFormEl, '#choices-' + selectedMethodGroupStr + ' .technical-method-group-items-content').length !==
                        eXpress.html.querySelectorAll(deliveryFormEl, '#choices-' + selectedMethodGroupStr + ' .technical-method-group-items-content .technical-delivery-time-picker-radio:checked').length) {
                        getLabelAsync("Label.Delivery.DeliveryMethod.NoDeliveryMomentSelected").then(function (res) { return showTopMessage(components.main.PageLogStyle.Error, res); });
                        button.enable();
                        return;
                    }
                    if (eXpress.html.querySelectorAll(deliveryFormEl, 'input[name="methodGroup"]:checked:not([data-forceaddresspopup="true"])').length === 0) {
                        getLabelAsync("Label.Delivery.DeliveryMethod.NoPickUpPointSelected").then(function (res) { return showTopMessage(components.main.PageLogStyle.Error, res); });
                        button.enable();
                        return;
                    }
                    if (selectedMethodGroupStr === 'homedelivery' && selectedMethod.dataset.currentAddress) {
                        var address_1 = JSON.parse(selectedMethod.dataset.currentAddress);
                        var useExternalAddressValidation = (selectedMethod.dataset.useexternaladdressvalidation || 'true') === "true";
                        if (useExternalAddressValidation)
                            components.main.validateAddressAsync(address_1.Street || '', address_1.HouseNumber || '', address_1.ZipCode || '', address_1.City || '', address_1.RegionCountryISO || '', { logError: logError }).then(function (res) {
                                if (res) {
                                    pickCorrectAddressPopup([
                                        { Street: eXpress.utils.capitalizeFirstLetterOfWords(res.street), HouseNumber: res.nr, ZipCode: res.zip, City: res.city, RegionCountryISO: address_1.RegionCountryISO, BoxNumber: address_1.BoxNumber, IsDefault: true },
                                        { Street: address_1.Street, HouseNumber: address_1.HouseNumber, ZipCode: address_1.ZipCode, City: address_1.City, BoxNumber: address_1.BoxNumber, RegionCountryISO: address_1.RegionCountryISO }
                                    ], function () { button.enable(); }, function (popup) {
                                        var list = eXpress.html.querySelector(popup, '.technical-pick-delivery-address-container', true);
                                        for (var i = 0; i < list.children.length; i++) {
                                            var input = eXpress.html.querySelector(list.children[i], 'input', true);
                                            eXpress.html.addEventListener(input, 'change', function (ev) {
                                                ev.preventDefault();
                                            });
                                            eXpress.html.addEventListener(list.children[i], 'click', function (ev) {
                                                var current = eXpress.html.querySelector(list, '.technical-default-address-tile.m-address-tile--active,.technical-address-tile.m-address-tile--active', true);
                                                current.classList.remove('m-address-tile--active');
                                                eXpress.html.querySelector(current, 'input', true).checked = false;
                                                if (ev.currentTarget) {
                                                    var changed = eXpress.html.querySelector(ev.currentTarget, '.technical-default-address-tile,.technical-address-tile', true);
                                                    changed.classList.add('m-address-tile--active');
                                                    eXpress.html.querySelector(changed, 'input', true).checked = true;
                                                }
                                            });
                                        }
                                        var continueButton = eXpress.html.querySelector(popup, '.technical-add-delivery-address-button', true);
                                        eXpress.html.addEventListener(continueButton, 'click', function () {
                                            var addressTile = eXpress.html.querySelector(popup, '.technical-default-address-tile', true);
                                            var hasSameDeliveryAddress = false;
                                            if (addressTile)
                                                hasSameDeliveryAddress = addressTile.getAttribute('data-hassamedeliveryaddress') === "True";
                                            var recommended = eXpress.html.querySelector(popup, '.technical-default-address-tile input', true);
                                            if (recommended.checked) {
                                                eXpress.analytics.trackAddressValidationEvent("ClickedAddressSuggestionDeliveryOptions");
                                                var address_2 = JSON.parse(recommended.value);
                                                if (address_2.Street) {
                                                    submitPartialDeliveryAddress(address_2.Street, hasSameDeliveryAddress).then(function () {
                                                        doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                                                    });
                                                }
                                            }
                                            else {
                                                eXpress.analytics.trackAddressValidationEvent("ClickedOwnAddressDeliveryOptions");
                                                doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                                            }
                                        });
                                    });
                                }
                                else {
                                    doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                                }
                            });
                        else
                            doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                        return;
                    }
                    doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                };
                var doActualSubmit = function (buttonEl, button, selectedMethodGroupStr) {
                    blocked = true;
                    var items = getDeliveryChoicesItemGroup(selectedMethodGroupStr);
                    if (!buttonEl.dataset)
                        throw new Error("Clicking next step on deliveryoptions: Button has no dataset: button css classes: " + buttonEl.className);
                    if (!buttonEl.dataset.posid)
                        throw new Error("Clicking next step on deliveryoptions: Button has no posID: button css classes: " + buttonEl.className);
                    if (!buttonEl.dataset.accountid)
                        throw new Error("Clicking next step on deliveryoptions: Button has no accountID: button css classes: " + buttonEl.className);
                    if (!buttonEl.dataset.cartid)
                        throw new Error("Clicking next step on deliveryoptions: Button has cartID: button css classes: " + buttonEl.className);
                    var postalInformationEl = eXpress.html.querySelector(deliveryFormEl, '#postal_information_personal_data', false);
                    var postalInformation = '';
                    if (postalInformationEl)
                        postalInformation = postalInformationEl.value;
                    eXpress.utils.showLoadingDialog(updateDeliveryChoices((buttonEl.dataset.posid), (buttonEl.dataset.accountid), (buttonEl.dataset.cartid), selectedMethodGroupStr, items, postalInformation)
                        .then(function (res) {
                        if (res) {
                            if (gtmData) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push(JSON.parse(gtmData));
                            }
                            document.location.href = res;
                            return eXpress.utils.wait(99999);
                        }
                        else {
                            button.enable();
                        }
                    }));
                };
                var onTimeSelectorClick = function (clickedEl, allEls) {
                    var selectedEl = allEls.find(function (el) { return eXpress.html.hasClass(el, activeClass); });
                    if (selectedEl) {
                        if (selectedEl.dataset.day === clickedEl.dataset.day)
                            return;
                        eXpress.html.removeClass(selectedEl, activeClass);
                    }
                    eXpress.html.addClass(clickedEl, activeClass);
                    var selectedDay = clickedEl.dataset.day || '';
                    var itemGroupContentEl = eXpress.html.getParentWithClassName(clickedEl, 'technical-method-group-items-content');
                    if (itemGroupContentEl) {
                        var resetUserChoice = false;
                        var radioWithLowestPrice_1;
                        var deliveryTypesRadioContainerEl = eXpress.html.querySelector(itemGroupContentEl, '.technical-delivery-types-radio-container', true);
                        var radios_1 = eXpress.html.querySelectorAll(deliveryTypesRadioContainerEl, 'input[type="radio"]');
                        var selectedRadio = eXpress.html.querySelector(deliveryTypesRadioContainerEl, 'input[type="radio"]:checked');
                        var _loop_1 = function (i) {
                            var radio = radios_1[i];
                            var allowedDatesString = radio.dataset.days || '';
                            var radioNoLongerAvailable = true;
                            radio.dataset.availablefordate = 'false';
                            allowedDatesString.split('|').forEach(function (d) {
                                if (selectedDay === d) {
                                    radioNoLongerAvailable = false;
                                    radio.dataset.availablefordate = 'true';
                                    if (radio.offsetParent) {
                                        if (radioWithLowestPrice_1) {
                                            var currentLowestExtraPrice = 0;
                                            var newExtraPrice = 0;
                                            if (radioWithLowestPrice_1.dataset.extraprice)
                                                currentLowestExtraPrice = parseFloat(radioWithLowestPrice_1.dataset.extraprice);
                                            if (radio.dataset.extraprice)
                                                newExtraPrice = parseFloat(radio.dataset.extraprice);
                                            if (newExtraPrice < currentLowestExtraPrice)
                                                radioWithLowestPrice_1 = radio;
                                        }
                                        else {
                                            radioWithLowestPrice_1 = radio;
                                        }
                                    }
                                }
                            });
                            if (radioNoLongerAvailable && radio === selectedRadio)
                                resetUserChoice = true;
                        };
                        for (var i = 0; i < radios_1.length; i++) {
                            _loop_1(i);
                        }
                        if (!selectedRadio || (resetUserChoice && resetSelectedRadioButtonAfterSlideChange)) {
                            for (var i = 0; i < radios_1.length; i++) {
                                var radio = radios_1[i];
                                if (radio.offsetParent && radio.dataset.availablefordate === 'true' && (radioWithLowestPrice_1 && radio.id === radioWithLowestPrice_1.id)) {
                                    radio.click();
                                    break;
                                }
                            }
                        }
                        resetSelectedRadioButtonAfterSlideChange = true;
                    }
                };
                var addOnTimeSelectorClick = function (clickedEl, allEls) {
                    clickedEl.addEventListener('click', function () { return onTimeSelectorClick(clickedEl, allEls); });
                };
                var initTimeSelectorElements = function (groupEl) {
                    var timeSelectorEls = eXpress.html.querySelectorAll(groupEl, '.technical-delivery-time-selector:not(.illegal)');
                    timeSelectorEls.forEach(function (el) {
                        if (!eXpress.html.hasClass(el, disabledClass))
                            addOnTimeSelectorClick(el, timeSelectorEls);
                    });
                };
                var onGroupChange = function (e) {
                    var radio = (e.target || e.srcElement);
                    if (radio.checked) {
                        hideTopMessage();
                        var val_1 = radio.value;
                        if (!deliveryFormEl)
                            return;
                        var deliveryAddresses = eXpress.html.querySelectorAll(deliveryFormEl, addressPickerClass);
                        for (var i = 0; i < deliveryAddresses.length; i++) {
                            var labelDeliveryMethods = eXpress.html.querySelector(deliveryAddresses[i], '.technical-method-group-gotodatepicker', false);
                            var radiobutton = eXpress.html.querySelector(deliveryAddresses[i], '.technical-method-group');
                            if (!labelDeliveryMethods || !radiobutton)
                                continue;
                            labelDeliveryMethods.classList.toggle('a-link--disabled', !radiobutton.checked);
                        }
                        var methodGroupContentEl = eXpress.html.querySelector(deliveryFormEl, '.technical-method-group-content', true);
                        eXpress.html.show(methodGroupContentEl);
                        var items = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-method-group-content-item');
                        items.map(function (item) {
                            if (item.id !== 'choices-' + val_1) {
                                eXpress.html.hide(item);
                            }
                            else {
                                eXpress.html.show(item);
                                checkAndHideIllegalMethods(radio.dataset.forceshipmentmethods || '', item);
                                var groupItemsContentEls = eXpress.html.querySelectorAll(item, '.technical-method-group-items-content');
                                groupItemsContentEls.forEach(function (groupItem) { return initTimeSelectorElements(groupItem); });
                            }
                        });
                        truncateThumbs();
                        currentVisibleItems = document.getElementById('choices-' + val_1);
                        if (currentVisibleItems) {
                            calculateSelectedShipping();
                        }
                        if (radio.dataset.forceaddresspopup === 'true' && pickupPickerButtonEl && !disableButtonClick) {
                            disableButtonClick = true;
                            pickupPickerPopup(pickupPickerButtonEl.dataset.deliverymethod || '', parseFloat(pickupPickerButtonEl.dataset.baseprice || '0')).always(function () { disableButtonClick = false; });
                        }
                    }
                };
                var checkAndHideIllegalMethods = function (forceShipmentMethod, groupContentItem) {
                    var allPackages = eXpress.html.querySelectorAll(groupContentItem, '.technical-method-group-items-content');
                    var visibleRadioCount = 0;
                    allPackages.forEach(function (onePackage) {
                        var allRadios = eXpress.html.querySelector(onePackage, '.technical-delivery-types-radio-container', true).children;
                        for (var i = 0; i < allRadios.length; i++) {
                            eXpress.html.show(allRadios[i]);
                        }
                        var forceShipmentMethods = forceShipmentMethod ? forceShipmentMethod.toLowerCase().split(',') : [];
                        if (forceShipmentMethods.length == 0) {
                            return;
                        }
                        var selectedRadioWasHidden = false;
                        var foundDays = [];
                        var firstVisibleMethodRadioButton = null;
                        var firstActivatedDay = "";
                        for (var i = 0; i < allRadios.length; i++) {
                            var childRadio = eXpress.html.querySelector(allRadios[i], '.technical-delivery-time-picker-radio', true);
                            if (!forceShipmentMethods.includes(childRadio.value.toLowerCase()) && childRadio.value.toLowerCase() !== 'email') {
                                if (childRadio.checked)
                                    selectedRadioWasHidden = true;
                                eXpress.html.hide(allRadios[i]);
                            }
                            else {
                                if (!firstVisibleMethodRadioButton) {
                                    firstVisibleMethodRadioButton = childRadio;
                                }
                                var radioDays = childRadio.dataset.days ? childRadio.dataset.days.split("|") : undefined;
                                if (radioDays) {
                                    if (!firstActivatedDay)
                                        firstActivatedDay = radioDays[0];
                                    foundDays.push.apply(foundDays, radioDays);
                                }
                                visibleRadioCount++;
                            }
                        }
                        var days = eXpress.html.querySelectorAll(onePackage, '.technical-delivery-time-selector');
                        var activateDayDiv = null;
                        for (var i = 0; i < days.length; i++) {
                            var day = days[i].dataset.day;
                            if (day) {
                                if (foundDays.indexOf(day) > -1) {
                                    days[i].classList.remove("illegal", "u-hide");
                                    if (!activateDayDiv && day === firstActivatedDay)
                                        activateDayDiv = days[i];
                                }
                                else {
                                    days[i].classList.add("illegal", "u-hide");
                                }
                            }
                        }
                        if (firstVisibleMethodRadioButton && (selectedRadioWasHidden || visibleRadioCount === 1)) {
                            firstVisibleMethodRadioButton.checked = true;
                            if (activateDayDiv) {
                                days.forEach(function (day) {
                                    day.classList.remove(activeClass);
                                });
                                activateDayDiv.classList.add(activeClass);
                            }
                        }
                    });
                };
                var onRadioChange = function (e) {
                    hideTopMessage();
                    var radio = (e.target || e.srcElement);
                    if (radio.checked)
                        calculateSelectedShipping();
                    var parent = eXpress.html.getParentWithClassName(radio, 'technical-method-group-items-content');
                    if (parent) {
                        var radios_2 = eXpress.html.querySelectorAll(parent, 'input[type="radio"]');
                        var timeSelectorEls = eXpress.html.querySelectorAll(parent, '.technical-delivery-time-selector:not(.illegal)');
                        radios_2.forEach(function (el) { return el.disabled = true; });
                        var activeTimeSelector = eXpress.html.querySelector(parent, '.' + activeClass);
                        var selectedTimeSelectorDay_1 = (activeTimeSelector === null || activeTimeSelector === void 0 ? void 0 : activeTimeSelector.dataset.day) || '';
                        var radioDateString = radio.dataset.days || '';
                        var radioAllAllowedDates_1 = radioDateString.split('|');
                        var switchTimeSelector_1 = true;
                        radioAllAllowedDates_1.forEach(function (d) {
                            if (d === selectedTimeSelectorDay_1)
                                switchTimeSelector_1 = false;
                        });
                        if (switchTimeSelector_1) {
                            if (activeClass && activeTimeSelector)
                                eXpress.html.removeClass(activeTimeSelector, activeClass);
                            timeSelectorEls.every(function (el) {
                                var slideDay = el.dataset.day || '';
                                if (radioAllAllowedDates_1.indexOf(slideDay) >= 0) {
                                    eXpress.html.addClass(el, activeClass);
                                    return false;
                                }
                                return true;
                            });
                        }
                        radios_2.forEach(function (el) { return el.disabled = false; });
                    }
                };
                var disableButtonClick = false;
                if (debugSectionEl && prettyButtonEl)
                    eXpress.html.addEventListener(prettyButtonEl, "click", prettyFi);
                eXpress.html.addEventListener(window, "resize", eXpress.utils.debounce(onWindowResize, 250));
                if (deliveryAddressPickerButtonEl)
                    eXpress.html.addEventListener(deliveryAddressPickerButtonEl, 'click', function () {
                        if (!disableButtonClick) {
                            disableButtonClick = true;
                            deliveryAddressPickerPopup().always(function () { disableButtonClick = false; });
                        }
                    });
                if (pickupPickerButtonEl)
                    eXpress.html.addEventListener(pickupPickerButtonEl, 'click', function () {
                        if (!disableButtonClick) {
                            disableButtonClick = true;
                            pickupPickerPopup(pickupPickerButtonEl.dataset.deliverymethod || '', parseFloat(pickupPickerButtonEl.dataset.baseprice || '0')).always(function () { disableButtonClick = false; });
                        }
                    });
                if (nextButtons)
                    nextButtons.forEach(function (nextButton) { return eXpress.html.addEventListener(nextButton, "click", onNextButtonClick); });
                if (groups)
                    groups.forEach(function (group) {
                        var _a;
                        eXpress.html.addEventListener(group, "click", onGroupChange);
                        (_a = group.closest(addressPickerClass)) === null || _a === void 0 ? void 0 : _a.classList.remove('skeleton-loading');
                    });
                if (radios)
                    radios.forEach(function (radio) { return eXpress.html.addEventListener(radio, "change", onRadioChange); });
                if (goToDeliveryMethodsLabels)
                    goToDeliveryMethodsLabels.forEach(function (label) { return eXpress.html.addEventListener(label, 'click', function (e) {
                        var labelHtmlElement = label;
                        if (label.classList.contains('a-link--disabled') || !labelHtmlElement || !labelHtmlElement.hash)
                            e.preventDefault();
                    }); });
                var checkedGroup = groups.filter(function (g) { return g.checked; });
                if (checkedGroup.length > 0) {
                    var group = checkedGroup[0].value;
                    currentVisibleItems = document.getElementById('choices-' + group);
                    if (currentVisibleItems) {
                        var forceShipmentMethods = checkedGroup[0].dataset.forceshipmentmethods;
                        if (forceShipmentMethods && forceShipmentMethods.length > 0)
                            checkAndHideIllegalMethods(forceShipmentMethods, currentVisibleItems);
                        var groupContentEls = eXpress.html.querySelectorAll(currentVisibleItems, '.technical-method-group-items-content');
                        groupContentEls.forEach(function (el) { return initTimeSelectorElements(el); });
                    }
                }
                var truncateThumbs = function () {
                    thumbInfoEls.map(function (el) {
                        var temp = el.innerHTML;
                        el.innerHTML = 'Test</br>Test';
                        var height = el.clientHeight;
                        el.innerHTML = temp;
                        shave(el, height, { character: '\u2026', spaces: false });
                    });
                };
                eXpress.html.addEventListener(window, "resize", eXpress.utils.debounce(truncateThumbs, 250));
                iconsEls.forEach(function (i) {
                    eXpress.html.addEventListener(i, "click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (disableButtonClick)
                            return;
                        disableButtonClick = true;
                        iconsPopup('Label.Delivery.DeliveryMethod.PickUpPoint.Info.Title', 'Label.Delivery.DeliveryMethod.PickUpPoint.Info').always(function () { return disableButtonClick = false; });
                    });
                });
                truncateThumbs();
                var resizeObserver = new ResizeObserver(function (entries) {
                    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                        var entry = entries_1[_i];
                        if (entry.contentRect && entry.target)
                            if (entry.contentRect.height != entry.target.clientHeight)
                                setRightColTopPosition(entry.target);
                    }
                });
                resizeObserver.observe(rightColumnEl);
                return {
                    changeHomeDeliveryAddress: changeHomeDeliveryAddress,
                    selectHomeDeliveryOption: selectHomeDeliveryOption
                };
            }
            checkout.createDeliveryInfo = createDeliveryInfo;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createDiscount(discountEl, deps) {
                var formEl;
                var buttonEl;
                var inputContainerEl;
                var inputEl;
                var promoCodeEl;
                var deleteEl;
                var discountTextEl;
                var mgmLinkEl;
                var eventDisposables;
                var introClicker;
                var onMglLinkElClick = function (e) {
                    e.preventDefault();
                    var mgmPromoCode = discountTextEl.dataset.promocode || '';
                    deps.changePromoCode(mgmPromoCode).then(function (res) {
                        discountTextEl.classList.add('u-hide');
                        if (res.InvalidPromoMessage) {
                            onDeleteClick(mgmPromoCode);
                            inputContainerEl.classList.add("a-form-input--error");
                            var messageEl = eXpress.html.querySelector(inputContainerEl, '.technical-discount-error', false);
                            if (messageEl)
                                messageEl.innerHTML = res.InvalidPromoMessage;
                            return;
                        }
                        eXpress.analytics.trackMgmEvent('MGMPromoCodeRe-enabled');
                        if (promoCodeEl)
                            promoCodeEl.innerHTML = mgmPromoCode;
                        discountEl.classList.add('m-discount--success');
                        if (deps.refreshMiniBasket)
                            deps.refreshMiniBasket(res.NewMiniBasketHtml);
                    });
                };
                var onIntroClick = function () {
                    initIntro();
                    inputContainerEl.classList.remove("a-form-input--error");
                };
                var onButtonClick = function (event) {
                    event.preventDefault();
                    var promoCode = inputEl.value;
                    if (!promoCode)
                        return;
                    var buttonDisabledClass = 'a-button--disabled';
                    if (buttonEl.classList.contains(buttonDisabledClass))
                        return;
                    buttonEl.classList.add(buttonDisabledClass);
                    var reEnableButton = function () {
                        clearTimeout(buttonDisableTimeout);
                        buttonEl.classList.remove(buttonDisabledClass);
                    };
                    var buttonDisableTimeout = setTimeout(function () { return reEnableButton(); }, 10000);
                    if (!eXpress.utils.isValidTextWithoutAngleBrackets(promoCode)) {
                        setErrorMessage(eXpress.html.sanitize(promoCode));
                        reEnableButton();
                        return;
                    }
                    clearError();
                    deps.changePromoCode(promoCode).then(function (res) {
                        if (res.InvalidPromoMessage) {
                            inputContainerEl.classList.add("a-form-input--error");
                            var messageEl = eXpress.html.querySelector(inputContainerEl, '.technical-discount-error', false);
                            if (messageEl)
                                messageEl.innerHTML = res.InvalidPromoMessage;
                        }
                        else {
                            if (promoCodeEl)
                                promoCodeEl.innerHTML = promoCode;
                            discountEl.classList.add('m-discount--success');
                            if (deps.refreshMiniBasket)
                                deps.refreshMiniBasket(res.NewMiniBasketHtml);
                        }
                        reEnableButton();
                    });
                };
                var clearError = function () {
                    inputContainerEl.classList.remove("a-form-input--error");
                };
                var refreshServerSide = function (newContent) {
                    if (newContent) {
                        replaceHtml(newContent);
                        return;
                    }
                };
                var replaceHtml = function (htmlString) {
                    var node = eXpress.html.htmlToElement(htmlString);
                    if (node) {
                        discountEl.replaceWith(node);
                        discountEl = node;
                        addHandlers();
                    }
                };
                var onDeleteClick = function (overrideinputValue) {
                    deps.changePromoCode('').then(function (res) {
                        inputEl.value = overrideinputValue || '';
                        formEl.classList.add("m-discount--slide");
                        discountEl.classList.remove('m-discount--success');
                        discountTextEl.classList.add("u-hide");
                        if (deps.refreshMiniBasket)
                            deps.refreshMiniBasket(res.NewMiniBasketHtml);
                    });
                };
                var initIntro = function () {
                    discountEl.classList.remove("m-discount--clickable");
                    introClicker.dispose();
                    formEl.classList.add("m-discount--slide");
                };
                var setErrorMessage = function (promoCode, error) {
                    var messageEl = eXpress.html.querySelector(inputContainerEl, '.technical-discount-error', false);
                    inputContainerEl.classList.add("a-form-input--error");
                    if (messageEl) {
                        var messageElDataError = error ? error : messageEl.getAttribute("data-error");
                        if (messageElDataError)
                            messageEl.innerHTML = messageElDataError.replace("[promocode]", promoCode);
                    }
                };
                var addHandlers = function () {
                    formEl = eXpress.html.querySelector(discountEl, ".technical-discount-from", true);
                    buttonEl = eXpress.html.querySelector(discountEl, ".technical-discount-button", true);
                    inputContainerEl = eXpress.html.querySelector(formEl, ".technical-discount-inputcontainer", true);
                    inputEl = eXpress.html.querySelector(inputContainerEl, ".technical-discount-input", true);
                    promoCodeEl = eXpress.html.querySelector(discountEl, ".technical-discount-promocode", false);
                    deleteEl = eXpress.html.querySelector(discountEl, ".technical-discount-delete", true);
                    discountTextEl = eXpress.html.querySelector(discountEl, '.technical-discount-text', true);
                    mgmLinkEl = eXpress.html.querySelector(discountTextEl, '.technical-apply-mgm', false);
                    if (eventDisposables)
                        dispose();
                    eventDisposables = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(buttonEl, 'click', onButtonClick),
                        eXpress.html.addEventListener(deleteEl, 'click', function (_) { return onDeleteClick(); }),
                        eXpress.html.addEventListener(inputEl, 'focus', clearError),
                        eXpress.html.addEventListener(formEl, 'submit', onButtonClick)
                    ]);
                    introClicker = eXpress.html.addEventListener(discountEl, 'click', onIntroClick);
                    if (mgmLinkEl)
                        eXpress.html.addEventListener(mgmLinkEl, 'click', onMglLinkElClick);
                    var invalidPromoCode = discountEl.dataset.invalidpromocode;
                    var invalidPromoError = discountEl.dataset.invalidpromoerror;
                    if (invalidPromoCode && invalidPromoError) {
                        initIntro();
                        setErrorMessage(invalidPromoCode, invalidPromoError);
                    }
                };
                var dispose = function () {
                    if (introClicker)
                        introClicker.dispose();
                    eventDisposables.dispose();
                };
                addHandlers();
                return {
                    dispose: function () { return dispose(); },
                    refreshServerSide: function (newContent) { return refreshServerSide(newContent); }
                };
            }
            checkout.createDiscount = createDiscount;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createGoogleMap(containerEl, googleApiKey, googleMapId, options) {
                if (options === void 0) { options = {}; }
                var apiKey = googleApiKey;
                var mapId = googleMapId;
                var googleMapEl;
                var infoWindow;
                var isInitialized = false;
                var isInError = false;
                var markerInfos = [];
                var currentMapCenter = { latitude: 0, longitude: 0 };
                var disableMapRecenter = false;
                var mapRecenterTimeout;
                var mapRecentered = options.mapRecentered;
                var centerMap = function (latitude, longitude) {
                    if (isInitialized) {
                        if (currentMapCenter.latitude != latitude || currentMapCenter.longitude != longitude)
                            googleMapEl.setCenter(new google.maps.LatLng(latitude, longitude, false));
                        currentMapCenter = { latitude: latitude, longitude: longitude };
                    }
                    else if (!isInError)
                        setTimeout(function () { centerMap(latitude, longitude); }, 500);
                };
                var clearMarkers = function () {
                    markerInfos.forEach(function (m) { return m.MapsMarker.map = null; });
                    markerInfos = [];
                };
                var setMarkerContent = function (markerInfo) {
                    if (markerInfo.IsSelected) {
                        return;
                    }
                    if (!infoWindow) {
                        infoWindow = new google.maps.InfoWindow({ minWidth: 280 });
                    }
                    else {
                        infoWindow.close();
                    }
                    infoWindow.setContent(markerInfo.Marker.Text);
                    disableMapRecenter = true;
                    clearTimeout(mapRecenterTimeout);
                    mapRecenterTimeout = setTimeout(function () { disableMapRecenter = false; }, 2000);
                    infoWindow.open({ anchor: markerInfo.MapsMarker, shouldFocus: false });
                    markerInfos.forEach(function (m) {
                        m.MapsMarker.content = getNewPin(markerInfo.Marker, false);
                        m.IsSelected = false;
                    });
                    markerInfo.MapsMarker.content = getNewPin(markerInfo.Marker, true);
                    markerInfo.IsSelected = true;
                };
                var attachMarkerClickEvent = function (markerInfo) {
                    markerInfo.MapsMarker.addListener('click', function (_a) {
                        var domEvent = _a.domEvent, latLng = _a.latLng;
                        eXpress.html.querySelectorAll(document, ".technical-select-store").forEach(function (e) {
                            e.classList.remove("m-address-tile--active");
                            if (e.dataset.indx && +e.dataset.indx === markerInfo.Marker.Index) {
                                e.classList.add("m-address-tile--active");
                                if (e.parentElement)
                                    e.scrollIntoView({ behavior: "smooth" });
                                setMarkerContent(markerInfo);
                            }
                        });
                    });
                };
                var getNewPin = function (marker, isLarge) {
                    var baseWidth = 22;
                    var baseHeight = 33;
                    var height = baseHeight * (isLarge ? 1.7 : 1);
                    var pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" height="' + height + '" viewBox="0 0 ' + baseWidth + ' ' + baseHeight + '"><path fill="' + marker.Color + '" d="M7.332 11.232c0 2.016 1.632 3.648 3.642 3.648 2.016 0 3.654-1.632 3.654-3.648S12.996 7.584 10.98 7.584 7.332 9.216 7.332 11.232Zm3.642 21.87s-.006.018-.006.018S.45 16.98.45 11.676C.45 3.87 5.778.474 10.974.462 16.17.474 21.498 3.87 21.498 11.676c0 5.304-10.512 21.444-10.512 21.444s-.012-.012-.012-.018Z" /></svg>';
                    var parser = new DOMParser();
                    var pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;
                    return pinSvg;
                };
                var showMarker = function (marker) {
                    addMarkerToMap(marker);
                    var markerInfo = markerInfos.filter(function (m) { return m.Marker.Index === marker.Index; })[0];
                    if (markerInfo)
                        setMarkerContent(markerInfo);
                };
                var addMarkerToMap = function (marker) {
                    if (!marker.Latitude
                        || !marker.Longitude
                        || isInError) {
                        return;
                    }
                    if (!isInitialized) {
                        setTimeout(function () { addMarkerToMap(marker); }, 500);
                        return;
                    }
                    var currentMarkerInfo = markerInfos.filter(function (m) { return m.Marker.Index === marker.Index; })[0];
                    if (!currentMarkerInfo) {
                        currentMarkerInfo = {
                            MapsMarker: new google.maps.marker.AdvancedMarkerElement({
                                map: googleMapEl,
                                position: new google.maps.LatLng(marker.Latitude, marker.Longitude),
                                content: getNewPin(marker, false),
                                gmpClickable: true,
                            }),
                            Marker: marker,
                            IsSelected: false,
                        };
                        attachMarkerClickEvent(currentMarkerInfo);
                        markerInfos.push(currentMarkerInfo);
                    }
                };
                var initializeMap = function () {
                    googleMapEl = new google.maps.Map(containerEl, {
                        zoom: 12,
                        center: new google.maps.LatLng(0, 0),
                        scrollwheel: true,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        streetViewControl: false,
                        mapTypeControl: false,
                        mapId: mapId
                    });
                    if (mapRecentered) {
                        googleMapEl.addListener("center_changed", eXpress.utils.debounce(triggerMapCentered, 200));
                    }
                    isInitialized = true;
                };
                var triggerMapCentered = function () {
                    if (!mapRecentered || disableMapRecenter) {
                        return;
                    }
                    var center = googleMapEl.getCenter();
                    if (!center) {
                        return;
                    }
                    var latitude = center.lat();
                    var longitude = center.lng();
                    if (currentMapCenter.latitude != latitude || currentMapCenter.longitude != longitude) {
                        mapRecentered(center.lat(), center.lng());
                        currentMapCenter = { latitude: latitude, longitude: longitude };
                    }
                };
                var init = function () {
                    var src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&libraries=marker";
                    if (!document.querySelector('script[src="' + src + '"]')) {
                        loadScript(src).then(function () { return initializeMap(); }).fail(function () { return isInError = true; });
                    }
                    else {
                        initializeMap();
                    }
                };
                var loadScript = function (url) {
                    var deferred = $.Deferred();
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.defer = true;
                    script.src = url;
                    var firstScriptEl = document.getElementsByTagName('script')[0];
                    firstScriptEl.parentElement.insertBefore(script, firstScriptEl);
                    script.addEventListener('load', function () {
                        deferred.resolve();
                    });
                    script.addEventListener('error', function () {
                        deferred.reject();
                    });
                    return deferred.promise();
                };
                var deInit = function () {
                };
                init();
                return {
                    createMarker: function (marker) { return addMarkerToMap(marker); },
                    clearMarkers: clearMarkers,
                    showMarker: showMarker,
                    centerMap: centerMap,
                    dispose: deInit
                };
            }
            checkout.createGoogleMap = createGoogleMap;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            var MiniBasket = (function () {
                function MiniBasket(miniBasketEl, deps) {
                    this.collapsableInfos = [];
                    this.miniBasketEl = miniBasketEl;
                    this.deps = deps;
                    this.addHandlers();
                }
                MiniBasket.prototype.getTechClass = function (el) {
                    var found = "";
                    el.classList.forEach(function (className) {
                        if (className.includes("technical-")) {
                            found = className;
                        }
                    });
                    return found;
                };
                MiniBasket.prototype.addHandlers = function () {
                    var _this = this;
                    var collapsableEls = eXpress.html.querySelectorAll(this.miniBasketEl, '.m-collapsable');
                    if (collapsableEls) {
                        collapsableEls.forEach(function (collapsableEl) {
                            var collapsableElTechClass = _this.getTechClass(collapsableEl);
                            if (_this.collapsableInfos.filter(function (arrEl) { return arrEl.techClass === collapsableElTechClass; }).length === 0) {
                                _this.collapsableInfos.push({ techClass: collapsableElTechClass, el: collapsableEl, titleSelector: '.m-collapsable__title', collapsable: undefined, shouldReopen: false });
                            }
                        });
                    }
                    this.collapsableInfos.forEach(function (c) {
                        var _a;
                        var el = eXpress.html.querySelector(_this.miniBasketEl, '.' + c.techClass, false);
                        if (el) {
                            (_a = c.collapsable) === null || _a === void 0 ? void 0 : _a.dispose();
                            c.collapsable = components.main.createCollapsable(el, { titleElSelector: c.titleSelector, scrollIntoViewAfterOpen: false });
                            if (c.shouldReopen)
                                c.collapsable.open();
                        }
                    });
                };
                MiniBasket.prototype.refreshServerSide = function (overrideMiniBasketHtml) {
                    var _this = this;
                    if (overrideMiniBasketHtml) {
                        this.replaceHtml(overrideMiniBasketHtml);
                        return;
                    }
                    if (!this.deps.refreshMiniBasketApi)
                        return;
                    this.deps.refreshMiniBasketApi().then(function (res) {
                        _this.replaceHtml(res.NewMiniBasketHtml);
                    });
                };
                MiniBasket.prototype.replaceHtml = function (htmlString) {
                    var node = eXpress.html.htmlToElement(htmlString);
                    if (!node)
                        return;
                    this.collapsableInfos.forEach(function (c) {
                        var _a;
                        var shouldReopen = ((_a = c.collapsable) === null || _a === void 0 ? void 0 : _a.isOpen()) || false;
                        if (!shouldReopen) {
                            if (c.el)
                                shouldReopen = c.el.dataset.collapsedConfig === 'true';
                        }
                        c.shouldReopen = shouldReopen;
                    });
                    this.miniBasketEl.replaceWith(node);
                    this.miniBasketEl = node;
                    this.addHandlers();
                };
                return MiniBasket;
            }());
            checkout.MiniBasket = MiniBasket;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createOrders(containerEl, deps) {
                var orderCount = +(containerEl.dataset.ordercount || 10);
                var selectedOrderNumber = eXpress.utils.getParameter("ordernumber");
                var getOrderItemAsync = deps.getOrderItemAsync, openTrailDialog = deps.openTrailDialog;
                var createCollapsables = function (collapseEls) {
                    var counter = 0;
                    return collapseEls.map(function (el) {
                        counter++;
                        var orderId = el.dataset.orderid;
                        var orderNumber = el.dataset.ordernumber;
                        var onBeforeOpen = function () {
                            var contentEl = eXpress.html.querySelector(el, ".technical-collapse-content", true);
                            if (contentEl.innerHTML.indexOf("m-order-tile") !== -1)
                                return $.Deferred().resolve().promise();
                            return getOrderItemAsync(orderId)
                                .then(function (res) {
                                if (res.redirectUrl) {
                                    document.location.href = res.redirectUrl;
                                }
                                else {
                                    contentEl.insertAdjacentHTML("beforeend", res.content);
                                    init1Order(eXpress.html.querySelector(contentEl, ".technical-order-details", true));
                                }
                            });
                        };
                        var onBeforeClose = function () {
                            if (counter === 1)
                                eXpress.analytics.trackOrderStatusEvent('FirstTabClose', { orderNumber: orderNumber }, orderCount);
                            return $.Deferred().resolve().promise();
                        };
                        var collapsable = eXpress.components.main.createCollapsable(el, {
                            onBeforeOpen: onBeforeOpen,
                            onBeforeClose: onBeforeClose,
                            scrollIntoViewAfterOpen: true,
                            titleElSelector: '.technical-collapsable-title'
                        });
                        collapsable.orderNumber = orderNumber;
                        collapsable.isOldOrder = eXpress.html.hasClass(el, 'technical-older-order');
                        return collapsable;
                    });
                };
                var init1Order = function (orderDetails) {
                    var isConsolidated = orderDetails.classList.contains('technical-consolidated-order');
                    var orderNumber = orderDetails.dataset.ordernumber || '';
                    var trailDialogButtons = eXpress.html.querySelectorAll(orderDetails, ".technical-trail-dialog");
                    trailDialogButtons.forEach(function (el) { return el.addEventListener('click', function (ev) {
                        ev.preventDefault();
                        openTrailDialog(ev);
                        eXpress.analytics.trackOrderStatusEvent("TrailDialogOpen", { orderNumber: orderNumber, orderStatus: el.dataset.status, paymentStatus: el.dataset.paid, pvc: el.dataset.pvc });
                    }); });
                    var pdfLink = eXpress.html.querySelector(orderDetails, '.technical-orderpdf-download');
                    if (pdfLink)
                        pdfLink.addEventListener('click', function (ev) { return eXpress.analytics.trackOrderStatusEvent(isConsolidated ? "ConsolidatedOrderPDFDownload" : "OrderPDFDownload", { orderNumber: orderNumber }); });
                    var creditnoteLinks = eXpress.html.querySelectorAll(orderDetails, '.technical-creditnotepdf-download');
                    creditnoteLinks.forEach(function (link) { return link.addEventListener('click', function (ev) { return eXpress.analytics.trackOrderStatusEvent(isConsolidated ? "ConsolidatedCreditPDFDownload" : "CreditPDFDownload", { orderNumber: orderNumber }); }); });
                    eXpress.html.inViewTrigger(orderDetails, function () {
                        eXpress.analytics.trackOrderStatusEvent("OrderDetailsRead", { orderNumber: orderNumber });
                    });
                    var paymentDetailsEl = eXpress.html.querySelector(orderDetails, '.technical-payment-details', false);
                    if (paymentDetailsEl) {
                        eXpress.html.inViewTrigger(paymentDetailsEl, function () {
                            eXpress.analytics.trackOrderStatusEvent("PaymentDetailsRead", { orderNumber: orderNumber });
                        });
                    }
                    var ttLinks = eXpress.html.querySelectorAll(orderDetails, '.technical-tracktrace');
                    ttLinks.forEach(function (link) { return link.addEventListener('click', function (ev) {
                        var orderStatus = '';
                        var pvc = '';
                        var parent = eXpress.html.getParentWithClassName(link, "technical-order-item-tile");
                        if (parent) {
                            var trailButton = eXpress.html.querySelector(parent, '.technical-trail-dialog', false);
                            if (trailButton) {
                                orderStatus = trailButton.dataset.status || '';
                                pvc = trailButton.dataset.pvc || '';
                            }
                        }
                        eXpress.analytics.trackOrderStatusEvent("TrackTraceClick", { orderNumber: orderNumber, orderStatus: orderStatus, pvc: pvc });
                    }); });
                    var voucherLinks = eXpress.html.querySelectorAll(orderDetails, '.technical-voucher');
                    voucherLinks.forEach(function (link) { return link.addEventListener('click', function (ev) {
                        var orderStatus = '';
                        var pvc = '';
                        var parent = eXpress.html.getParentWithClassName(link, "technical-order-item-tile");
                        if (parent) {
                            var trailButton = eXpress.html.querySelector(parent, '.technical-trail-dialog', false);
                            if (trailButton) {
                                orderStatus = trailButton.dataset.status || '';
                                pvc = trailButton.dataset.pvc || '';
                            }
                        }
                        eXpress.analytics.trackOrderStatusEvent("VoucherDownload", { orderNumber: orderNumber, orderStatus: orderStatus, pvc: pvc });
                    }); });
                };
                var toggleOlderOrders = function (show) {
                    return collapsables.filter(function (c) { return c.isOldOrder; })
                        .forEach(function (c) { return show ? c.show() : c.hide(); });
                };
                var createOlderButton = function () {
                    var buttonEl = eXpress.html.querySelector(containerEl, ".technical-show-older-button", true);
                    var hideLabel = buttonEl.dataset.hideLabel || "";
                    var showLabel = buttonEl.textContent || "";
                    var olderShown = false;
                    var toggleButton = function () {
                        olderShown = !olderShown;
                        buttonEl.innerText = olderShown ? hideLabel : showLabel;
                        eXpress.analytics.trackOrderStatusEvent(olderShown ? 'OlderOrdersShow' : 'OlderOrdersHide', {}, orderCount);
                        toggleOlderOrders(olderShown);
                    };
                    buttonEl.addEventListener('click', toggleButton);
                    return {
                        dispose: function () { return buttonEl.removeEventListener('click', toggleButton); },
                        toggleButton: toggleButton
                    };
                };
                var collapsables = createCollapsables(eXpress.html.querySelectorAll(containerEl, ".m-collapsable"));
                collapsables
                    .filter(function (c) { return !c.isOldOrder; })
                    .forEach(function (c) { return c.show(); });
                var olderButton = collapsables.some(function (o) { return o.isOldOrder || false; }) && createOlderButton();
                if (selectedOrderNumber) {
                    collapsables.forEach(function (c) { return c.close(); });
                    var selected = collapsables.filter(function (c) { return (c.orderNumber) ? c.orderNumber.toLowerCase() === selectedOrderNumber.toLowerCase() : false; })[0];
                    if (selected.isOldOrder) {
                        olderButton && olderButton.toggleButton();
                    }
                    selected.open(true);
                }
                var alreadyLoadedContent = eXpress.html.querySelectorAll(containerEl, ".technical-order-details");
                alreadyLoadedContent.forEach(function (el) { init1Order(el); });
                var noOrders = eXpress.html.querySelector(containerEl, '.technical-no-orders', false);
                if (noOrders)
                    eXpress.html.inViewTrigger(noOrders, function (element) {
                        eXpress.analytics.trackOrderStatusEvent("NoOrdersRead", {});
                    });
                return {
                    dispose: function () {
                        collapsables.map(function (c) { return c.dispose(); });
                        olderButton && olderButton.dispose();
                    }
                };
            }
            checkout.createOrders = createOrders;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createPersonalData(containerEl, deps) {
                var sameAddressEl = eXpress.html.querySelector(containerEl, '.technical-same-address', false);
                var getZipCodeDefinitionAsync = deps.getZipCodeDefinitionAsync, getCitiesForCountryCodeAndSearchTerm = deps.getCitiesForCountryCodeAndSearchTerm, getGetCitiesByZipCode = deps.getGetCitiesByZipCode, submitPersonalData = deps.submitPersonalData, showTopMessage = deps.showTopMessage, hideTopMessage = deps.hideTopMessage, showAccountSoftDeletedPopup = deps.showAccountSoftDeletedPopup, onDirtyNavigateAway = deps.onDirtyNavigateAway;
                var formEl = eXpress.html.querySelector(containerEl, '.technical-personal-data', true);
                var companyCheck = eXpress.html.querySelector(formEl, '.technical-company', false);
                var advantageListEl = eXpress.html.querySelector(containerEl, '.technical-advantages-list', false);
                var passwordFormInput = eXpress.html.querySelector(formEl, '.technical-password', false);
                var createAdvantagesAnimation = function (listItem) {
                    var advantageListItemEls = eXpress.html.querySelectorAll(listItem, 'li');
                    var currentIndex = 0;
                    var displayTime = 2000;
                    var transitionTime = 1000;
                    var showNextItem = function () {
                        var prevIndex = (currentIndex - 1 + advantageListItemEls.length) % advantageListItemEls.length;
                        advantageListItemEls[prevIndex].style.opacity = "0";
                        var currentItem = advantageListItemEls[currentIndex];
                        currentItem.style.opacity = "1";
                        currentIndex = (currentIndex + 1) % advantageListItemEls.length;
                        setTimeout(function () {
                            showNextItem();
                        }, displayTime + transitionTime);
                    };
                    advantageListItemEls.forEach(function (el) {
                        el.style.opacity = "0";
                    });
                    showNextItem();
                };
                var onSubmit = function (formData) {
                    var billingAddress = {};
                    var deliveryAddress = {};
                    var keys = Object.keys(formData);
                    for (var i = 0, l = keys.length; i < l; i++) {
                        var key = keys[i];
                        if (key.match('billingaddress')) {
                            billingAddress[key.replace('billingaddress', '')] = formData[key];
                        }
                        else if (key.match('deliveryaddress')) {
                            deliveryAddress[key.replace('deliveryaddress', '')] = formData[key];
                        }
                    }
                    if (!sameAddressEl || (sameAddressEl && sameAddressEl.checked))
                        deliveryAddress = billingAddress;
                    var password = formData['password'];
                    if (passwordFormInput && eXpress.html.hasClass(passwordFormInput, "u-hide")) {
                        password = '';
                    }
                    var convertedFormData = {
                        BillingAddress: Object.keys(billingAddress).length !== 0 ? billingAddress : null,
                        DeliveryAddress: Object.keys(deliveryAddress).length !== 0 ? deliveryAddress : null,
                        MobileNumber: formData['mobilenumber'] || '',
                        Password: password ? eXpress.utils.stringToBase64(password) : '',
                        Email: formData['email'] || '',
                        PersonalNumber: formData['personalnumber'] || '',
                        VatNumber: companyCheck && companyCheck.checked ? formData['vatnumber'] || '' : '',
                        CompanyName: companyCheck && companyCheck.checked ? formData['companyname'] || '' : '',
                        FirstName: formData['firstname'] || '',
                        LastName: formData['lastname'] || '',
                        IsCompany: companyCheck && companyCheck.checked || false,
                        __RequestVerificationToken: formData['__RequestVerificationToken'] || '',
                    };
                    submitPersonalData(convertedFormData)
                        .then(function (res) {
                        if (res.redirectUrl) {
                            window.location.href = res.redirectUrl;
                            return eXpress.utils.wait(99999);
                        }
                        res.softDelete && showAccountSoftDeletedPopup(convertedFormData, function (name, error) { return personalDataForm.setErrors(false, { name: name, error: error }); }, "/cart/personaldata");
                        res.blockingErrorMessage && showTopMessage(components.main.PageLogStyle.Error, res.blockingErrorMessage);
                        res.errorMessage && personalDataForm.setErrors(false, { name: res.errorMessage.name, error: res.errorMessage.message });
                        return $.Deferred().resolve().promise();
                    });
                    return $.Deferred().resolve().promise();
                };
                var personalDataForm = createPersonalDataForm(formEl, {
                    onSubmit: function (formData) { return eXpress.utils.showLoadingDialog(onSubmit(formData)); },
                    getZipCodeDefinitionAsync: getZipCodeDefinitionAsync,
                    getCitiesForCountryCodeAndSearchTerm: getCitiesForCountryCodeAndSearchTerm,
                    getGetCitiesByZipCode: getGetCitiesByZipCode,
                    alternativeSubmitButtonEl: eXpress.html.querySelector(containerEl, '.technical-personal-data-submit', true),
                    hideTopMessage: hideTopMessage,
                    showTopMessage: showTopMessage,
                    updateCountryText: false,
                    onDirtyNavigateAway: onDirtyNavigateAway
                });
                advantageListEl && createAdvantagesAnimation(advantageListEl);
                return {
                    updatePersonalDataForm: function (accountData) { return personalDataForm.updateWithAccountData(accountData); },
                    finishPersonalDataInlineLogin: function (data) {
                        personalDataForm.fillFormData(data);
                    },
                    showRegisterSection: function () { personalDataForm.showRegisterSection(); },
                    showGuestSection: function () { personalDataForm.showGuestSection(); },
                    hideForm: function () { personalDataForm.hideForm(); },
                    showForm: function () { personalDataForm.showForm(); }
                };
            }
            checkout.createPersonalData = createPersonalData;
            function createPersonalDataForm(formEL, deps) {
                var privateCheck = eXpress.html.querySelector(formEL, '.technical-private', false);
                var companyCheck = eXpress.html.querySelector(formEL, '.technical-company', false);
                var sameAddressEl = eXpress.html.querySelector(formEL, '.technical-same-address', false);
                var companynameDivEl = eXpress.html.querySelector(formEL, '.technical-company-name', false);
                var deliveryAddress = eXpress.html.querySelector(formEL, '#technical-delivery-address', false);
                var billingAddress = eXpress.html.querySelector(formEL, '#technical-billing-address', false);
                var titleEl = eXpress.html.querySelector(formEL, '.technical-billing-address-title', false);
                var title = (titleEl === null || titleEl === void 0 ? void 0 : titleEl.textContent) || '';
                var addressId = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.dataset.id;
                var popupCase = addressId == '00000000-0000-0000-0000-000000000000' ? AddressComponentCases.Create : AddressComponentCases.Edit;
                var address = formEL.id === 'technical-address' ? formEL : eXpress.html.querySelector(formEL, '#technical-address', false);
                var companyVatNumberDivEl = eXpress.html.querySelector(formEL, '.technical-company-vat-number', false);
                var orderAsCompanyMessage = formEL.dataset.orderAsCompanyMessage || '';
                var showOrderAsCompanyMessage = formEL.dataset.showOrderAsCompanyMessage === 'true' || false;
                var companyChecked = companyCheck && companyCheck.checked;
                var billingAddressSection;
                var deliveryAddressSection;
                var addressSection;
                var eventDisposables = eXpress.utils.compositeDisposable([]);
                var onSubmit = deps.onSubmit, getZipCodeDefinitionAsync = deps.getZipCodeDefinitionAsync, getCitiesForCountryCodeAndSearchTerm = deps.getCitiesForCountryCodeAndSearchTerm, getGetCitiesByZipCode = deps.getGetCitiesByZipCode, alternativeSubmitButtonEl = deps.alternativeSubmitButtonEl, hideTopMessage = deps.hideTopMessage, showTopMessage = deps.showTopMessage, updateCountryText = deps.updateCountryText, onDirtyNavigateAway = deps.onDirtyNavigateAway;
                var onSameAddressClick = function () {
                    deliveryAddress && deliveryAddress.classList.toggle('u-hide');
                    if (!titleEl)
                        return;
                    var fallbackTitle = titleEl.dataset.fallbacktitle || '';
                    if (!title || !fallbackTitle)
                        return;
                    titleEl.textContent = titleEl.textContent === fallbackTitle
                        ? title
                        : fallbackTitle;
                };
                var onCompanyCheckClick = function () {
                    if (companyCheck && companyCheck.checked && !companyChecked) {
                        companynameDivEl && companynameDivEl.classList.toggle('u-hide');
                        companyVatNumberDivEl && companyVatNumberDivEl.classList.toggle('u-hide');
                        companyChecked = true;
                        var defaultRegionCode = formEL.dataset.defaultCountry || formEL.dataset.defaultRegions || '';
                        var selectedDeliveryRegionCode = void 0, selectedBillingRegionCode = '';
                        if (addressSection)
                            addressSection.updateCountry(defaultRegionCode, true);
                        if (deliveryAddressSection) {
                            selectedDeliveryRegionCode = deliveryAddressSection.getCurrentRegionCode();
                            deliveryAddressSection.updateCountry(defaultRegionCode, true);
                        }
                        if (billingAddressSection) {
                            selectedBillingRegionCode = billingAddressSection.getCurrentRegionCode();
                            billingAddressSection.updateCountry(defaultRegionCode, true);
                        }
                        if (showTopMessage && (defaultRegionCode !== selectedDeliveryRegionCode || defaultRegionCode !== selectedBillingRegionCode))
                            showTopMessage(components.main.PageLogStyle.WarningOrange, orderAsCompanyMessage);
                        personalDataForm.setErrors(true);
                    }
                };
                var onPrivateCheckClick = function () {
                    if (privateCheck && privateCheck.checked && companyChecked) {
                        companynameDivEl && companynameDivEl.classList.toggle('u-hide');
                        companyVatNumberDivEl && companyVatNumberDivEl.classList.toggle('u-hide');
                        companyChecked = false;
                        if (addressSection)
                            addressSection.disableCountry(false, true);
                        if (deliveryAddressSection)
                            deliveryAddressSection.disableCountry(false, true);
                        if (billingAddressSection)
                            billingAddressSection.disableCountry(false, true);
                        if (hideTopMessage)
                            hideTopMessage();
                        personalDataForm.setErrors(true);
                    }
                };
                if (eventDisposables && eventDisposables.add) {
                    if (sameAddressEl)
                        eventDisposables.add([eXpress.html.addEventListener(sameAddressEl, 'click', onSameAddressClick)]);
                    if (companyCheck)
                        eventDisposables.add([eXpress.html.addEventListener(companyCheck, 'change', onCompanyCheckClick)]);
                    if (privateCheck)
                        eventDisposables.add([eXpress.html.addEventListener(privateCheck, 'click', onPrivateCheckClick)]);
                }
                var personalDataForm = components.main.initForm(formEL, {
                    onSubmitForm: onSubmit,
                    alternativeButton: alternativeSubmitButtonEl,
                    submitOnEnter: true,
                    validatorOptions: { onValidate: hideTopMessage },
                    onDirtyNavigateAway: onDirtyNavigateAway
                });
                if (deliveryAddress) {
                    if (sameAddressEl)
                        window.onload = function () { deliveryAddress.classList.toggle('u-hide', sameAddressEl.checked); };
                    deliveryAddressSection = createAddressSection(deliveryAddress, popupCase, {
                        getZipCodeDefinitionAsync: getZipCodeDefinitionAsync,
                        updateCountryText: updateCountryText !== null && updateCountryText !== void 0 ? updateCountryText : true,
                        getCitiesForCountryCodeAndSearchTerm: getCitiesForCountryCodeAndSearchTerm,
                        getGetCitiesByZipCode: getGetCitiesByZipCode,
                        clearFormInput: function (name) { return personalDataForm.clearInputs(true, name); },
                    }, 'deliveryAddress');
                }
                if (billingAddress) {
                    billingAddressSection = createAddressSection(billingAddress, popupCase, {
                        getZipCodeDefinitionAsync: getZipCodeDefinitionAsync,
                        updateCountryText: updateCountryText !== null && updateCountryText !== void 0 ? updateCountryText : true,
                        getCitiesForCountryCodeAndSearchTerm: getCitiesForCountryCodeAndSearchTerm,
                        getGetCitiesByZipCode: getGetCitiesByZipCode,
                        clearFormInput: function (name) { return personalDataForm.clearInputs(true, name); }
                    }, 'billingAddress');
                }
                if (address) {
                    addressSection = createAddressSection(address, popupCase, {
                        getZipCodeDefinitionAsync: getZipCodeDefinitionAsync,
                        updateCountryText: updateCountryText !== null && updateCountryText !== void 0 ? updateCountryText : true,
                        getCitiesForCountryCodeAndSearchTerm: getCitiesForCountryCodeAndSearchTerm,
                        getGetCitiesByZipCode: getGetCitiesByZipCode,
                        clearFormInput: function (name) { return personalDataForm.clearInputs(true, name); }
                    }, 'address');
                }
                var updateWithAccountData = function (data) {
                    var nameValues = [];
                    Object.keys(data).map(function (k) {
                        if (data[k]) {
                            nameValues.push({ name: k, value: data[k] });
                        }
                    });
                    personalDataForm.setValues.apply(personalDataForm, nameValues);
                    personalDataForm.disableForm(false);
                    data['Email'] && personalDataForm.disableInput('email');
                };
                var fillFormData = function (data, disableDefaultAddress, countryChangeEnabled) {
                    var nameValues = [];
                    if (deliveryAddress && data.DeliveryAddress) {
                        fillAddress(data.DeliveryAddress, 'deliveryAddress', nameValues);
                        deliveryAddressSection.updateCountry(nameValues.filter(function (nv) { return nv.name === 'deliveryAddressCountryId'; })[0].value);
                    }
                    if (billingAddress && data.BillingAddress) {
                        fillAddress(data.BillingAddress, 'billingAddress', nameValues);
                        billingAddressSection.updateCountry(nameValues.filter(function (nv) { return nv.name === 'billingAddressCountryId'; })[0].value);
                    }
                    if (data.PersonalNumber)
                        nameValues.push({ name: 'PersonalNumber', value: data.PersonalNumber });
                    if (data.MobileNumber)
                        nameValues.push({ name: 'MobileNumber', value: data.MobileNumber });
                    if (data.Email)
                        nameValues.push({ name: 'Email', value: data.Email });
                    personalDataForm.setValues.apply(personalDataForm, nameValues);
                    if (!addressSection)
                        personalDataForm.disableForm(false);
                    personalDataForm.disableInput('email');
                    if (!countryChangeEnabled) {
                        if (data.BillingAddress)
                            personalDataForm.disableInput("billingAddressCountryId");
                        if (data.DeliveryAddress)
                            personalDataForm.disableInput("deliveryAddressCountryId");
                    }
                    if (!data.BillingAddress && data.DeliveryAddress && data.DeliveryAddress.VatNumber && !addressSection)
                        personalDataForm.disableInput('VatNumber');
                    if (!data.BillingAddress && data.DeliveryAddress && data.DeliveryAddress.IsDefault || disableDefaultAddress)
                        personalDataForm.disableInput('DefaultAddress');
                    personalDataForm.hideInput('password');
                    if (data.PersonalNumber)
                        personalDataForm.hideInput('PersonalNumber');
                };
                var fillAddress = function (address, prefix, nameValues) {
                    Object.keys(address).map(function (k) {
                        if (address[k]) {
                            var alternateName = undefined;
                            if (k.toLocaleLowerCase() === 'regioncountryiso'
                                || k.toLocaleLowerCase() === 'country') {
                                alternateName = "CountryId";
                            }
                            if (k.toLocaleLowerCase() === 'isdefault') {
                                nameValues.push({ name: 'DefaultAddress', value: address[k] });
                            }
                            else if (k.toLocaleLowerCase() === 'firstname' || k.toLocaleLowerCase() === 'lastname' || k.toLocaleLowerCase() === 'vatnumber' || k.toLocaleLowerCase() === 'companyname') {
                                if (address[k] && !nameValues[k])
                                    nameValues.push({ name: k, value: address[k] });
                            }
                            else {
                                nameValues.push({ name: prefix + (alternateName ? alternateName : k), value: address[k] });
                            }
                        }
                    });
                };
                if (showOrderAsCompanyMessage && orderAsCompanyMessage && showTopMessage)
                    showTopMessage(components.main.PageLogStyle.WarningOrange, orderAsCompanyMessage);
                var enableFormAndButton = function () {
                    eXpress.html.removeClass(formEL, "u-hide");
                    personalDataForm.enableButton();
                };
                var showRegisterSection = function () {
                    enableFormAndButton();
                    personalDataForm.showInput('password');
                    personalDataForm.setRequiredOnInput('password', true);
                };
                var showGuestSection = function () {
                    enableFormAndButton();
                    personalDataForm.hideInput('password');
                    personalDataForm.clearInputs(true, 'password');
                    personalDataForm.setRequiredOnInput('password', false);
                };
                return __assign(__assign(__assign(__assign(__assign({}, personalDataForm), deliveryAddressSection), billingAddressSection), addressSection), { fillFormData: fillFormData, updateWithAccountData: updateWithAccountData, dispose: function () {
                        personalDataForm.dispose();
                        deliveryAddressSection && deliveryAddressSection.dispose();
                        billingAddressSection && billingAddressSection.dispose();
                        addressSection && addressSection.dispose();
                        eventDisposables.dispose();
                    }, showRegisterSection: showRegisterSection, showGuestSection: showGuestSection, hideForm: function () { eXpress.html.addClass(formEL, "u-hide"); } });
            }
            checkout.createPersonalDataForm = createPersonalDataForm;
            var AddressComponentCases;
            (function (AddressComponentCases) {
                AddressComponentCases[AddressComponentCases["Edit"] = 0] = "Edit";
                AddressComponentCases[AddressComponentCases["Create"] = 1] = "Create";
            })(AddressComponentCases || (AddressComponentCases = {}));
            var createAddressSection = function (addressSectionEl, popupCase, deps, prefix) {
                var getZipCodeDefinitionAsync = deps.getZipCodeDefinitionAsync, updateCountryText = deps.updateCountryText, getCitiesForCountryCodeAndSearchTerm = deps.getCitiesForCountryCodeAndSearchTerm, getGetCitiesByZipCode = deps.getGetCitiesByZipCode, clearFormInput = deps.clearFormInput;
                var countrySelectBoxEl = eXpress.html.querySelector(addressSectionEl, "#".concat(prefix ? prefix : '', "CountryId"), true);
                var zipCodeInputEl = eXpress.html.querySelector(addressSectionEl, "#".concat(prefix ? prefix : '', "ZipCode"), true);
                var cityInputEl = eXpress.html.querySelector(addressSectionEl, "#".concat(prefix ? prefix : '', "City"), true);
                var citiesSelectEl = eXpress.html.querySelector(addressSectionEl, "#".concat(prefix ? prefix : '', "Cities"), true);
                var cityRemoveButtonEl = eXpress.html.querySelector(addressSectionEl, '.technical-remove-city-selection', true);
                var defaultRegions = addressSectionEl.dataset.defaultRegions || '';
                var deliveryAbroadEnabled = addressSectionEl.dataset.deliveryAbroadEnabled ? addressSectionEl.dataset.deliveryAbroadEnabled === "true" : true;
                var cityInputElWithAutoComplete;
                var firstZipCheck = popupCase === AddressComponentCases.Edit;
                var previousZip = '-1';
                var findZipCodeFromSelect = true;
                var toggleCitySelectControl = function (show) {
                    eXpress.html.toggleClass(eXpress.html.getParentWithClassName(citiesSelectEl, 'a-form-input'), 'u-hide', !show);
                    eXpress.html.toggleClass(eXpress.html.getParentWithClassName(cityInputEl, 'a-form-input'), 'u-hide', show);
                    eXpress.html.toggleClass(cityRemoveButtonEl, 'u-hide', !show);
                    citiesSelectEl.removeAttribute("required");
                    cityInputEl.removeAttribute("required");
                    show
                        ? citiesSelectEl.setAttribute("required", "required")
                        : cityInputEl.setAttribute("required", "required");
                };
                var resetCityControls = function () {
                    var prefix = 'deliveryaddress';
                    clearFormInput("".concat(prefix, "city"));
                    clearFormInput("".concat(prefix, "cities"));
                    toggleCitySelectControl(false);
                };
                var onZipCodeKey = function (fromSelect) {
                    var regexp = zipCodeInputEl.getAttribute('regex');
                    var value = zipCodeInputEl.value;
                    var currentCity = cityInputEl.value;
                    var selectedIndex = -1;
                    if (!value || (previousZip === value && !fromSelect) || !regexp || !new RegExp(regexp).test(value))
                        return;
                    previousZip = value;
                    getGetCitiesByZipCode(value, currentSelectedCountry).then(function (res) {
                        if (res && res.length) {
                            citiesSelectEl.innerHTML = '';
                            res.forEach(function (city, index) {
                                var option = document.createElement('option');
                                option.value = city;
                                option.innerHTML = city;
                                citiesSelectEl.appendChild(option);
                                if (city.toLowerCase() == currentCity.toLowerCase())
                                    selectedIndex = index;
                            });
                        }
                        if (selectedIndex > -1)
                            citiesSelectEl.selectedIndex = selectedIndex;
                        if (firstZipCheck && selectedIndex < 0) {
                            firstZipCheck = false;
                        }
                        else {
                            if (firstZipCheck)
                                firstZipCheck = false;
                            cityInputEl.value = (selectedIndex > -1 && currentCity) || (res && res[0] && res[0]) || currentCity;
                            toggleCitySelectControl(res && res.length > 0);
                        }
                    });
                };
                var currentSelectedCountry = countrySelectBoxEl.value;
                var updateCountryAsync = function (regionCode, disable, resetOptions, overrideDefaultRegions) {
                    if (disable === void 0) { disable = false; }
                    if (resetOptions === void 0) { resetOptions = false; }
                    if (overrideDefaultRegions === void 0) { overrideDefaultRegions = ''; }
                    countrySetDisabled(false);
                    if (regionCode && regionCode !== currentSelectedCountry) {
                        if (countrySelectBoxEl.value !== regionCode)
                            countrySelectBoxEl.value = regionCode;
                        currentSelectedCountry = regionCode;
                        disable && countrySetDisabled(disable, resetOptions, overrideDefaultRegions);
                        var disableSetAsDefault_1 = false;
                        if (overrideDefaultRegions)
                            disableSetAsDefault_1 = !deliveryAbroadEnabled && overrideDefaultRegions.indexOf(currentSelectedCountry) !== -1;
                        else
                            disableSetAsDefault_1 = !deliveryAbroadEnabled && defaultRegions.indexOf(currentSelectedCountry) !== -1;
                        return getZipCodeDefinitionAsync(regionCode)
                            .then(function (res) { return res && updateAddressSection(res, disableSetAsDefault_1, true); });
                    }
                    else {
                        disable && countrySetDisabled(disable, resetOptions, overrideDefaultRegions);
                        return $.Deferred().resolve().promise();
                    }
                };
                var onCountrySelectedChange = function () {
                    currentSelectedCountry = countrySelectBoxEl.options[countrySelectBoxEl.selectedIndex].value;
                };
                var getSelectedCountry = function () {
                    return currentSelectedCountry;
                };
                var updateAddressSection = function (def, disableSetAsDefault, clearInputs) {
                    var inputEls = eXpress.html.querySelectorAll(addressSectionEl, 'input').filter(function (el) { return el.name.toLowerCase() !== "deliveryaddressfirstname" && el.name.toLowerCase() !== "deliveryaddresslastname"; });
                    if (clearInputs)
                        clearAddressSection(inputEls);
                    var countryInputEl = eXpress.html.querySelector(document, '#' + (prefix ? prefix : '') + 'CountryId', false);
                    if (updateCountryText && countryInputEl)
                        updateAddressSelect(countryInputEl, def);
                    var zipcodeInputEl = inputEls.find(function (x) { return x.id === ((prefix ? prefix : '') + 'ZipCode'); });
                    if (zipcodeInputEl) {
                        if (prefix && prefix === 'deliveryAddress')
                            zipcodeInputEl.setAttribute("blacklist", def.BlackListedZipCodes);
                        updateAddressInput(zipcodeInputEl, def);
                        if (countryInputEl)
                            zipcodeInputEl.setAttribute('format-example', countryInputEl.value === 'SWE' && def.ExampleZipCodeOfRegion ? def.ExampleZipCodeOfRegion : '');
                    }
                    setPlaceholder(inputEls, prefix, 'ZipCode', def.LabelPlaceHolder);
                    toggleCitySelectControl(false);
                    citiesSelectEl.value = '';
                    disableDefaultAddressInputElement(inputEls.filter(function (el) { return el.id === "DefaultAddress"; })[0], disableSetAsDefault);
                };
                var setPlaceholder = function (inputEls, prefix, key, val) {
                    var inputEl = inputEls.find(function (x) { return x.id === ((prefix ? prefix : '') + key); });
                    if (inputEl) {
                        inputEl.setAttribute('placeholder', val !== null && val !== void 0 ? val : "");
                    }
                };
                var disableDefaultAddressInputElement = function (el, disable) {
                    if (el) {
                        var parent_1 = eXpress.html.getParentWithClassName(el, "a-form-input");
                        if (disable) {
                            el.disabled = true;
                            el.checked = false;
                            parent_1 && parent_1.classList.add("a-form-input--disabled");
                        }
                        else {
                            el.disabled = false;
                            parent_1 && parent_1.classList.remove("a-form-input--disabled");
                        }
                    }
                };
                var clearAddressSection = function (inputEls, clearNames) {
                    if (clearNames === void 0) { clearNames = false; }
                    return inputEls.map(function (el) {
                        if (clearNames)
                            clearFormInput(el.id.toLowerCase());
                        else if (!el.id.toLowerCase().includes('firstname') && !el.id.toLowerCase().includes('lastname')) {
                            clearFormInput(el.id.toLowerCase());
                        }
                    });
                };
                var updateAddressSelect = function (selectEl, rule) {
                    if (rule) {
                        Object.keys(rule)
                            .forEach(function (key) { return addOrRemoveRulesToSelect(selectEl, key.toLowerCase(), rule[key]); });
                    }
                };
                var updateAddressInput = function (inputEl, rule) {
                    if (rule) {
                        Object.keys(rule)
                            .forEach(function (key) { return addOrRemoveRulesToInput(inputEl, key.toLowerCase(), rule[key]); });
                    }
                };
                var addAutoCompleteToInputEl = function (el) {
                    return components.main.createTextInputWithAutoComplete(el, {
                        autoCompleteSearch: function (term) { return getCitiesForCountryCodeAndSearchTerm(term, currentSelectedCountry)
                            .then(function (res) { return res.map(function (x) { return ({ value: x.zipcode, label: x.name }); }); }); },
                        onSelect: function (item) {
                            item.value && (zipCodeInputEl.value = item.value);
                            if (item.value)
                                onZipCodeKey(findZipCodeFromSelect);
                        },
                        preventSubmit: true,
                    });
                };
                var addOrRemoveRulesToSelect = function (el, ruleName, ruleValue) {
                    var inputContainerEl = el.parentElement;
                    var infoTextEl = eXpress.html.querySelector(inputContainerEl, '.a-form-input__info-text');
                    switch (ruleName.toLowerCase()) {
                        case 'nodeliverypossible':
                            if (infoTextEl)
                                infoTextEl.innerHTML = ruleValue ? ruleValue.toString() : "";
                            break;
                        default:
                            break;
                    }
                    infoTextEl && infoTextEl.textContent
                        ? eXpress.html.removeClass(infoTextEl, 'u-hide')
                        : infoTextEl && eXpress.html.addClass(infoTextEl, 'u-hide');
                };
                var addOrRemoveRulesToInput = function (el, ruleName, ruleValue) {
                    var inputContainerEl = el.parentElement;
                    var labelEl = eXpress.html.querySelector(inputContainerEl, '.a-form-input__label');
                    var infoTextEl = eXpress.html.querySelector(inputContainerEl, '.a-form-input__info-text');
                    switch (ruleName.toLowerCase()) {
                        case 'maxlength':
                        case 'regex':
                        case 'autocomplete':
                        case 'mandatory':
                            ruleValue ? el.setAttribute(ruleName, ruleName === "autocomplete" ? "shipping ".concat(ruleValue.toString()) : ruleValue.toString()) : el.removeAttribute(ruleName);
                            break;
                        case 'label':
                            if (labelEl)
                                labelEl.innerHTML = ruleValue.toString();
                            break;
                        case 'labelplaceholder':
                            el.setAttribute('placeholder', ruleValue.toString());
                            break;
                        case 'example':
                        case 'examplezipcode':
                            if (infoTextEl)
                                infoTextEl.innerHTML = ruleValue ? ruleValue.toString() : "";
                            break;
                        case 'zipcodesuggestions':
                            if (!el)
                                break;
                            el.dataset.zipcodesuggestions = ruleValue ? ruleValue.toString() : "true";
                            cityInputElWithAutoComplete && cityInputElWithAutoComplete.dispose();
                            if (ruleValue.toString() === "true")
                                cityInputElWithAutoComplete = addAutoCompleteToInputEl(el);
                            break;
                        default:
                            break;
                    }
                    infoTextEl && infoTextEl.textContent
                        ? eXpress.html.removeClass(infoTextEl, 'u-hide')
                        : infoTextEl && eXpress.html.addClass(infoTextEl, 'u-hide');
                };
                components.main.createSelectBox(countrySelectBoxEl.parentElement, function (value) { return updateCountryAsync(value || "", false, false); });
                components.main.createSelectBox(citiesSelectEl.parentElement, function (city) { return cityInputEl.value = city || ""; });
                if (cityInputEl && cityInputEl.dataset.zipcodesuggestions && cityInputEl.dataset.zipcodesuggestions === "true") {
                    cityInputElWithAutoComplete = addAutoCompleteToInputEl(eXpress.html.querySelector(addressSectionEl, "#".concat(prefix ? prefix : '', "City"), true));
                }
                var disposableEvents = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(zipCodeInputEl, 'keyup', function () { onZipCodeKey(!findZipCodeFromSelect); }),
                    eXpress.html.addEventListener(zipCodeInputEl, 'focusout', function () { onZipCodeKey(!findZipCodeFromSelect); }),
                    eXpress.html.addEventListener(cityRemoveButtonEl, 'click', resetCityControls),
                    eXpress.html.addEventListener(countrySelectBoxEl, 'change', onCountrySelectedChange)
                ]);
                var countrySetDisabled = function (disabled, resetOptions, overrideDefaultRegions) {
                    var _a, _b;
                    if (resetOptions === void 0) { resetOptions = false; }
                    if (overrideDefaultRegions === void 0) { overrideDefaultRegions = ''; }
                    var regionsToCheck = overrideDefaultRegions || defaultRegions;
                    if (disabled) {
                        var parentEl = eXpress.html.getParentWithClassName(countrySelectBoxEl, 'a-form-input');
                        if (parentEl && parentEl.classList.contains('a-form-input--error'))
                            parentEl.classList.remove('a-form-input--error');
                        if (regionsToCheck.indexOf("|") !== -1) {
                            for (var i = 0; i < countrySelectBoxEl.options.length; i++) {
                                var option = countrySelectBoxEl.options[i];
                                if (defaultRegions.indexOf(option.value) === -1) {
                                    option.hidden = true;
                                }
                            }
                        }
                        else {
                            countrySelectBoxEl.disabled = true;
                            (_a = countrySelectBoxEl.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('a-form-input--disabled');
                        }
                    }
                    else {
                        if (regionsToCheck.indexOf("|") !== -1 && resetOptions) {
                            for (var i = 0; i < countrySelectBoxEl.options.length; i++) {
                                var option = countrySelectBoxEl.options[i];
                                option.hidden = false;
                            }
                        }
                        else {
                            countrySelectBoxEl.disabled = false;
                            (_b = countrySelectBoxEl.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('a-form-input--disabled');
                        }
                    }
                };
                onZipCodeKey(!findZipCodeFromSelect);
                return {
                    dispose: function () {
                        resetCityControls();
                        disposableEvents.dispose();
                    },
                    updateCountry: updateCountryAsync,
                    disableCountry: countrySetDisabled,
                    getCurrentRegionCode: getSelectedCountry
                };
            };
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createPickDeliveryAddress(popupEl, deps) {
                var setDefaultDeliveryAddressAsync = deps.setDefaultDeliveryAddressAsync, deliveryAddressPopup = deps.deliveryAddressPopup, removeDeliveryAddressConfirmationPopup = deps.removeDeliveryAddressConfirmationPopup, parentDialog = deps.parentDialog, selectHomeDeliveryOption = deps.selectHomeDeliveryOption;
                var containerEl = eXpress.html.querySelector(popupEl, '.technical-pick-delivery-address-container', true);
                var buttonContainerEl = eXpress.html.querySelector(popupEl, '.technical-pick-delivery-address-button-container', true);
                var addressTileEls = eXpress.html.querySelectorAll(containerEl, '.technical-address-tile, .technical-default-address-tile');
                var disabledAddressTileEls = eXpress.html.querySelectorAll(containerEl, '.technical-address-tile-disabled');
                var editDeliveryAddressButtonEls = eXpress.html.querySelectorAll(containerEl, '.technical-edit-delivery-address-button');
                var deleteDeliveryAddressButtonEls = eXpress.html.querySelectorAll(containerEl, '.technical-delete-delivery-address-button');
                var addDeliveryAddressButtonEl = eXpress.html.querySelector(buttonContainerEl, '.technical-add-delivery-address-button', true);
                var onAddressTileClick = function (ev, el) {
                    var currentEl = ev.target;
                    if (!currentEl.classList.contains("technical-edit-delivery-address-button") &&
                        !currentEl.classList.contains("technical-delete-delivery-address-button")) {
                        var isDefaultAddressTile = eXpress.html.getParentWithClassName(currentEl, 'technical-default-address-tile');
                        if (!isDefaultAddressTile) {
                            var addressId = el.dataset.id ? el.dataset.id : "";
                            if (addressId) {
                                setDefaultDeliveryAddressAsync(addressId);
                            }
                        }
                        else {
                            selectHomeDeliveryOption();
                            parentDialog.close(true);
                        }
                    }
                };
                var onDisabledAddressTileClick = function (ev, el) {
                    var currentEl = ev.target;
                    if (!currentEl.classList.contains("technical-edit-delivery-address-button") && !currentEl.classList.contains("technical-delete-delivery-address-button")) {
                        ev.preventDefault();
                        return false;
                    }
                };
                var onAddAddressButtonClick = function (ev) {
                    deliveryAddressPopup(parentDialog);
                };
                var onDeleteAddressButtonClick = function (ev) {
                    var buttonEl = ev.target;
                    var addressTileEl = eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile')
                        || eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile-disabled');
                    if (addressTileEl) {
                        var addressId = addressTileEl.dataset.id ? addressTileEl.dataset.id : "";
                        if (addressId !== "")
                            removeDeliveryAddressConfirmationPopup(parentDialog, addressId);
                    }
                };
                var onEditAddressButtonClick = function (ev) {
                    var buttonEl = ev.target;
                    var isDisabled = eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile-disabled') !== null;
                    var addressTileEl = eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile')
                        || eXpress.html.getParentWithClassName(buttonEl, 'technical-default-address-tile')
                        || eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile-disabled');
                    if (addressTileEl) {
                        var countryChangeEnabled = addressTileEl.dataset.countryEnabled === "true";
                        deliveryAddressPopup(parentDialog, addressTileEl.dataset.id || "", isDisabled, countryChangeEnabled);
                    }
                };
                var init = function () {
                    addressTileEls.forEach(function (el) { return el.addEventListener('click', function (ev) { return onAddressTileClick(ev, el); }); });
                    disabledAddressTileEls.forEach(function (el) { return el.addEventListener('click', function (ev) { return onDisabledAddressTileClick(ev, el); }); });
                    editDeliveryAddressButtonEls.forEach(function (el) { return el.addEventListener('click', onEditAddressButtonClick); });
                    deleteDeliveryAddressButtonEls.forEach(function (el) { return el.addEventListener('click', onDeleteAddressButtonClick); });
                    addDeliveryAddressButtonEl.addEventListener('click', onAddAddressButtonClick);
                };
                var deInit = function () {
                    addressTileEls.forEach(function (el) { return el.removeEventListener("click", function (ev) { return onAddressTileClick(ev, el); }); });
                    disabledAddressTileEls.forEach(function (el) { return el.removeEventListener('click', function (ev) { return onDisabledAddressTileClick(ev, el); }); });
                    editDeliveryAddressButtonEls.forEach(function (el) { return el.removeEventListener('click', onEditAddressButtonClick); });
                    deleteDeliveryAddressButtonEls.forEach(function (el) { return el.removeEventListener("click", onDeleteAddressButtonClick); });
                    addDeliveryAddressButtonEl.removeEventListener("click", onAddAddressButtonClick);
                };
                init();
                return {
                    dispose: deInit
                };
            }
            checkout.createPickDeliveryAddress = createPickDeliveryAddress;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createPickupDelivery(popupEl, deps) {
                var savePickupPointsAsync = deps.savePickupPointsAsync, searchPickupPoints = deps.searchPickupPoints, searchPickupPointsByCoordinates = deps.searchPickupPointsByCoordinates, changeCountryForPickupPointsAsync = deps.changeCountryForPickupPointsAsync, getCitiesForCountryCodeAndSearchTerm = deps.getCitiesForCountryCodeAndSearchTerm, createMarker = deps.createMarker, showMarker = deps.showMarker, centerMap = deps.centerMap, clearMarkers = deps.clearMarkers, showTopMessage = deps.showTopMessage, pickupChangeAddress = deps.pickupChangeAddress;
                var pickupFormEl = eXpress.html.querySelector(popupEl, 'form.technical-pickup-form', true);
                var pickupPointsListEl = eXpress.html.querySelector(popupEl, ".technical-pickuppoints", true);
                var pickupPointsContainer = eXpress.html.querySelector(popupEl, ".technical-map-container", true);
                var pickupPointsNoResultsEl = eXpress.html.querySelector(popupEl, ".technical-pickuppoints-noresult", true);
                var selectedCountry = pickupFormEl.dataset.countrycode ? pickupFormEl.dataset.countrycode : 'BEL';
                var selectPickUpLabel = pickupFormEl.getAttribute("data-pickup-select-label") || "Select a collection point";
                var zipCodeInputEl = eXpress.html.querySelector(pickupFormEl, "#ZipCode", true);
                var cityInputEl = eXpress.html.querySelector(pickupFormEl, '#City', true);
                var preselectedZipCode = zipCodeInputEl.value;
                var formComponent = components.main.initForm(pickupFormEl, {
                    onSubmitForm: function (formData) { return searchAndUpdatePickuppoints(formData['zipcode']); },
                    validatorOptions: ({
                        shouldScrollToFirstError: true,
                        ignore: '.ignore'
                    })
                });
                var changeCountry = function (e) {
                    e.preventDefault();
                    var countryInputEl = e.currentTarget;
                    selectedCountry = countryInputEl.value;
                    changeCountryForPickups(selectedCountry, countryInputEl.options[countryInputEl.selectedIndex].getAttribute("data-searchtype") || undefined, countryInputEl.options[countryInputEl.selectedIndex].getAttribute("selected") || undefined);
                };
                var changeCountryForPickups = function (selectedCountry, searchType, selected) {
                    changeCountryForPickupPointsAsync(selectedCountry, searchType)
                        .then(function (res) {
                        if (res) {
                            var showOnlyInSearchEls = eXpress.html.querySelectorAll(popupEl, ".technical-show-in-search");
                            if (res.showAsList)
                                showOnlyInSearchEls.forEach(function (el) { return el.classList.add("u-hide"); });
                            else
                                showOnlyInSearchEls.forEach(function (el) { return el.classList.remove("u-hide"); });
                            if (zipCodeInputEl) {
                                var zipCodeExampleEl = eXpress.html.querySelector(popupEl, ".technical-zipcode-exampletext", false);
                                if (zipCodeExampleEl && res.zipCodeExample)
                                    zipCodeExampleEl.innerHTML = res.zipCodeExample;
                                if ((zipCodeInputEl.parentElement && zipCodeInputEl.parentElement.classList.contains('u-hide')) || (zipCodeInputEl.classList.contains('u-hide'))) {
                                    zipCodeInputEl.removeAttribute('required');
                                    zipCodeInputEl.removeAttribute('maxlength');
                                    zipCodeInputEl.removeAttribute('regex');
                                    zipCodeInputEl.value = '';
                                }
                                else {
                                    zipCodeInputEl.setAttribute('required', 'required');
                                    zipCodeInputEl.setAttribute("regex", res.zipCodeRegex);
                                    if (selected && preselectedZipCode.match(res.zipCodeRegex))
                                        zipCodeInputEl.value = preselectedZipCode;
                                }
                            }
                            if (zipCodeInputEl && zipCodeInputEl.value && !res.showAsList) {
                                searchAndUpdatePickuppoints(zipCodeInputEl.value);
                            }
                            else {
                                updatePickupPointList(res.res, true);
                                attachEventAndMarkerForStoreToMap(true);
                            }
                        }
                        return res;
                    });
                };
                var updatePickupPointList = function (data, scollToTop) {
                    pickupPointsListEl.innerHTML = data;
                    if (scollToTop)
                        pickupPointsContainer.scrollIntoView({ block: 'nearest' });
                };
                var searchAndUpdatePickuppoints = function (zipcode) {
                    if (zipcode) {
                        return searchPickupPoints(zipcode)
                            .then(function (res) {
                            if (res) {
                                updatePickupPointList(res, true);
                                attachEventAndMarkerForStoreToMap(true);
                            }
                            eXpress.html.toggleClass(pickupPointsNoResultsEl, 'u-hide', !!res);
                        });
                    }
                    else {
                        return $.Deferred().resolve().promise();
                    }
                };
                var searchAndUpdatePickuppointsByCoordinates = function (latitude, longitude) {
                    if (latitude && longitude) {
                        return searchPickupPointsByCoordinates(latitude, longitude)
                            .then(function (res) {
                            if (res) {
                                updatePickupPointList(res, false);
                                attachEventAndMarkerForStoreToMap(false);
                            }
                            eXpress.html.toggleClass(pickupPointsNoResultsEl, 'u-hide', !!res);
                        });
                    }
                    else {
                        return $.Deferred().resolve().promise();
                    }
                };
                var attachEventAndMarkerForStoreToMap = function (allowCenterMap) {
                    if (pickupPointsListEl) {
                        var storesToSelect_1 = eXpress.html.querySelectorAll(pickupPointsListEl, '.technical-select-store');
                        if (allowCenterMap && storesToSelect_1.length > 0) {
                            var latitude = parseFloat((storesToSelect_1[0].dataset.lat || "0").replace(",", "."));
                            var longitude = parseFloat((storesToSelect_1[0].dataset.lng || "0").replace(",", "."));
                            centerMap(latitude, longitude);
                        }
                        storesToSelect_1
                            .forEach(function (el) {
                            var radios = eXpress.html.querySelectorAll(document, '.technical-delivery-time-picker-radio');
                            var arr = radios.filter(function (f) { return f.dataset.shipmentpartnername && el.dataset.partnercode && f.dataset.shipmentpartnername.toLowerCase() === el.dataset.partnercode.toLowerCase(); });
                            if (arr.length) {
                                var shipmentPartner = arr[0];
                                if (shipmentPartner.dataset.showshipmentinfo && JSON.parse(shipmentPartner.dataset.showshipmentinfo)) {
                                    var shipmentPartnerExtraCost = eXpress.html.querySelector(el, '.technical-shipment-extracost');
                                    if (shipmentPartnerExtraCost) {
                                        shipmentPartnerExtraCost.classList.remove("u-hide");
                                        shipmentPartnerExtraCost.innerHTML = shipmentPartner.dataset.shipmentextracost || '';
                                    }
                                    var shipmentPartnerFirstDeliveryDay = eXpress.html.querySelector(el, '.technical-shipment-day');
                                    if (shipmentPartnerFirstDeliveryDay) {
                                        shipmentPartnerFirstDeliveryDay.classList.remove("u-hide");
                                        shipmentPartnerFirstDeliveryDay.innerHTML = shipmentPartner.dataset.shipmentday || '';
                                    }
                                }
                            }
                        });
                        pickupPointsContainer.classList.remove("u-hide");
                        if (storesToSelect_1 && storesToSelect_1.length < 1 && pickupPointsNoResultsEl) {
                            pickupPointsContainer.classList.add("u-hide");
                        }
                        else {
                            clearMarkers();
                            storesToSelect_1.map(function (el) { return ({
                                data: convertStoreElement(el),
                                el: el
                            }); })
                                .reverse()
                                .forEach(function (e) { return selectStore(e, storesToSelect_1.indexOf(e.el)); });
                        }
                    }
                    else if (pickupPointsContainer.classList.contains("u-hide")) {
                        pickupPointsContainer.classList.add("u-hide");
                    }
                };
                var showMarkerInfo = function (storeEl, marker) {
                    if (pickupPointsListEl)
                        eXpress.html.querySelectorAll(pickupPointsListEl, ".m-address-tile--active")
                            .forEach(function (el) { return el.classList.remove("m-address-tile--active"); });
                    storeEl.classList.add("m-address-tile--active");
                    showMarker(marker);
                };
                var selectStoreAndClose = function (store) {
                    if (formComponent.validate()) {
                        var firstNameEl = eXpress.html.querySelector(pickupFormEl, "#FirstName", true);
                        var firstName = firstNameEl.value;
                        var lastNameEl = eXpress.html.querySelector(pickupFormEl, "#LastName", true);
                        var lastName = lastNameEl.value;
                        var zipCodeInputEl_1 = eXpress.html.querySelector(pickupFormEl, "#ZipCode", true);
                        var zipCode = zipCodeInputEl_1.value;
                        var mobilePhoneEl = eXpress.html.querySelector(pickupFormEl, "#MobileNumber", false);
                        var mobileNumber = mobilePhoneEl && mobilePhoneEl.value;
                        var customerData_1 = {
                            FirstName: firstName,
                            LastName: lastName,
                            PostalCode: zipCode,
                            SendSms: !!mobileNumber,
                            MobileNumber: mobileNumber || '',
                            Address: store.address,
                            PostalCity: store.postalCity,
                            Name: store.name
                        };
                        savePickupPointsAsync(customerData_1, store.dropoffPointId, store.partnerCode)
                            .then(function (res) {
                            if (res.Error) {
                                showTopMessage(components.main.PageLogStyle.Error, res.Error);
                            }
                            else {
                                pickupChangeAddress(customerData_1.Name, "".concat(customerData_1.FirstName, " ").concat(customerData_1.LastName, ", ").concat(customerData_1.Address, ", ").concat(customerData_1.PostalCity), store.forceShipmentMethods, store.phone, store.holiday);
                            }
                        });
                    }
                };
                var selectStore = function (store, index) {
                    var data = store.data, el = store.el;
                    var selectButtonEl = eXpress.html.querySelector(el, ".technical-select-button", true);
                    var infoText = "\n\t\t\t\t<div class=\"p-pick-up-points__map__info-window\">\n\t\t\t\t\t<div class=\"p-pick-up-points__map__address-content\">\n\t\t\t\t\t\t<div class=\"p-pick-up-points__map__delivery-image\">\n\t\t\t\t\t\t\t<img src=\"".concat(data.partnerLogoUrl, "\" alt=\"").concat(data.partnerCode, "\" />\n\t\t\t\t\t\t\t").concat(data.is247 ? '<span class="a-icon a-icon--single a-icon--no-fill"><i class="p-pick-up-points__map__icon icon-twenty-four-seven"></i></span> ' : '', "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"p-pick-up-points__map__address-info\">\n\t\t\t\t\t\t\t<div class=\"p-pick-up-points__map__icon-container\">\n\t\t\t\t\t\t\t\t<span class=\"a-icon a-icon--single a-icon--no-fill\">\n\t\t\t\t\t\t\t\t\t<i class=\"p-pick-up-points__map__icon icon-pinpoint\"></i>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"p-pick-up-points__map__address-container\">\n\t\t\t\t\t\t\t\t<span class=\"p-pick-up-points__map__address-name\">").concat(data.name, "</span>\n\t\t\t\t\t\t\t\t<span class=\"p-pick-up-points__map__address-street\">").concat(data.address, "</span>\n\t\t\t\t\t\t\t\t<span class=\"p-pick-up-points__map__address-city\">").concat(data.postalCity, "</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"p-pick-up-points__map__additional-info\">\n\t\t\t\t\t\t<span class=\"p-pick-up-points__map__delivery-costs\">").concat(data.shipmentextracost, "</span>\n\t\t\t\t\t\t<span class=\"p-pick-up-points__map__delivery-date\">").concat(data.shipmentday, "</span>\n\t\t\t\t\t\t<button class='a-button a-button--small p-pick-up-points__map__select-button a-button--close technical-select-button' onclick='document.querySelector(\".p-pick-up-points .m-address-tile--active\").querySelector(\".technical-select-button\").click()'>").concat(selectPickUpLabel, "</button>\n\t\t\t\t\t\t<div class=\"p-pick-up-points__map__opening-hours\">").concat(data.openingHours, "</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>");
                    var marker = {
                        Name: data.name,
                        Address: data.address,
                        Latitude: data.lat,
                        Longitude: data.lng,
                        Index: index,
                        Text: infoText,
                        Color: data.partnerColor
                    };
                    createMarker(marker);
                    eXpress.html.addEventListener(el, "click", function () { return showMarkerInfo(el, marker); });
                    eXpress.html.addEventListener(selectButtonEl, 'click', function () { return selectStoreAndClose(data); });
                };
                var convertStoreElement = function (storeEl) {
                    var _a;
                    var openingHours = eXpress.html.querySelector(storeEl, '.technical-openinghours', false);
                    var radios = eXpress.html.querySelectorAll(document, '.technical-delivery-time-picker-radio');
                    var arr = radios.filter(function (f) { return f.dataset.shipmentpartnername && storeEl.dataset.partnercode && f.dataset.shipmentpartnername.toLowerCase() === storeEl.dataset.partnercode.toLowerCase(); });
                    var shipmentday = '';
                    var shipmentextracost = '';
                    if (arr.length) {
                        var shipmentPartner = arr[0];
                        if (shipmentPartner.dataset.showshipmentinfo && JSON.parse(shipmentPartner.dataset.showshipmentinfo)) {
                            var shipmentPartnerExtraCost = eXpress.html.querySelector(storeEl, '.technical-shipment-extracost');
                            if (shipmentPartnerExtraCost) {
                                shipmentPartnerExtraCost.classList.remove("u-hide");
                                shipmentextracost = shipmentPartner.dataset.shipmentextracost || '';
                                shipmentPartnerExtraCost.innerHTML = shipmentPartner.dataset.shipmentextracost || '';
                            }
                            var shipmentPartnerFirstDeliveryDay = eXpress.html.querySelector(storeEl, '.technical-shipment-day');
                            if (shipmentPartnerFirstDeliveryDay) {
                                shipmentPartnerFirstDeliveryDay.classList.remove("u-hide");
                                shipmentday = shipmentPartner.dataset.shipmentday || '';
                                shipmentPartnerFirstDeliveryDay.innerHTML = shipmentPartner.dataset.shipmentday || '';
                            }
                        }
                    }
                    var store = {
                        address: storeEl.dataset.address || "",
                        dropoffPointId: storeEl.dataset.dropoffpoint || "",
                        partnerCode: storeEl.dataset.partnercode || "",
                        partnerColor: storeEl.dataset.partnercolor || "",
                        name: storeEl.dataset.name || "",
                        postalCity: storeEl.dataset.city || "",
                        phone: storeEl.dataset.phone || "",
                        holiday: storeEl.dataset.holiday || "",
                        lat: +(storeEl.dataset.lat || '').replace(",", ".") || 0,
                        lng: +(storeEl.dataset.lng || '').replace(",", ".") || 0,
                        forceShipmentMethods: storeEl.dataset.forceshipmentmethods || '',
                        openingHours: openingHours ? openingHours.innerHTML : '',
                        is247: ((_a = storeEl.dataset.is247) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'true' ? true : false,
                        partnerLogoUrl: storeEl.dataset.partnerlogolink || '',
                        shipmentextracost: shipmentextracost,
                        shipmentday: shipmentday
                    };
                    return store;
                };
                var deInit = function () {
                    var countryInputEl = eXpress.html.querySelector(pickupFormEl, "#country_pickuppoints", false);
                    if (countryInputEl)
                        countryInputEl.removeEventListener('change', changeCountry);
                    inputDisposable.dispose();
                    formComponent.dispose();
                };
                var countryInputEl = eXpress.html.querySelector(pickupFormEl, "#country_pickuppoints", false);
                if (countryInputEl)
                    countryInputEl.addEventListener('change', changeCountry);
                var inputDisposable = eXpress.utils.compositeDisposable([
                    components.main.createTextInputWithAutoComplete(cityInputEl, {
                        autoCompleteSearch: function (term) {
                            return getCitiesForCountryCodeAndSearchTerm(term, selectedCountry)
                                .then(function (res) { return res.map(function (x) { return ({ value: x.zipcode, label: x.name }); }); });
                        },
                        onSelect: function (item) {
                            if (item.value) {
                                cityInputEl.dataset.ZipCode = item.value;
                                zipCodeInputEl.value = item.value;
                                if (formComponent.validate()) {
                                    searchAndUpdatePickuppoints(item.value);
                                }
                            }
                        },
                        preventSubmit: true
                    }), eXpress.html.addEventListener(zipCodeInputEl, 'change', function () {
                        preselectedZipCode = zipCodeInputEl.value;
                        cityInputEl.value = '';
                    })
                ]);
                if (countryInputEl && countryInputEl.options) {
                    var selectedOption = countryInputEl.options[countryInputEl.selectedIndex] || countryInputEl.options[0];
                    selectedCountry = countryInputEl.value;
                    changeCountryForPickups(selectedCountry, selectedOption.getAttribute("data-searchtype") || undefined, countryInputEl.options[countryInputEl.selectedIndex].getAttribute("selected") || undefined);
                }
                else {
                    attachEventAndMarkerForStoreToMap(true);
                }
                return {
                    dispose: deInit,
                    centerChanged: searchAndUpdatePickuppointsByCoordinates
                };
            }
            checkout.createPickupDelivery = createPickupDelivery;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createPlaceOrder(containerEl, deps) {
                var _this = this;
                var submitButtonEl = eXpress.html.querySelector(containerEl, ".technical-place-order-submit", false);
                var requiredCheckBoxes = eXpress.html.querySelectorAll(containerEl, ".a-form-input__input[required]");
                var adyenDropInContainerEl = eXpress.html.querySelector(containerEl, "#dropin-container", false);
                var paymentOptionsContainerEl = eXpress.html.querySelector(containerEl, '.technical-paymentoptions', true);
                var newsletterEl = eXpress.html.querySelector(containerEl, ".technical-newsletter", true);
                var personalMessageEl = eXpress.html.querySelector(containerEl, ".technical-personal-message", true);
                var testOrderOptionEl = eXpress.html.querySelector(containerEl, ".technical-testorderoption", false);
                var newsletter = false;
                var personalMessage = false;
                var dropIns;
                var requiredFormInputs = [];
                var eventDisposables = eXpress.utils.compositeDisposable([]);
                var placeOrder = deps.placeOrder, placeOfflineOrder = deps.placeOfflineOrder, getPaymentMethods = deps.getPaymentMethods, initiatePayment = deps.initiatePayment, submitAdditionalDetails = deps.submitAdditionalDetails, updateCartHandlingCost = deps.updateCartHandlingCost, disableStoredPaymentMethod = deps.disableStoredPaymentMethod;
                var recaptchaEnabled = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.recaptchaenabled === "true" || false;
                var useEnterprise = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.recaptchaenterpriseenabled === "true";
                var fetchRecaptchaToken = function () {
                    return new Promise(function (resolve, _) {
                        var siteKey = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.sitekey || "";
                        var key = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.key || "";
                        if (useEnterprise) {
                            grecaptcha.enterprise.execute(key, { action: 'cart_payment' })
                                .then(function (token) {
                                resolve(token);
                            });
                        }
                        else {
                            grecaptcha.execute(siteKey, { action: 'cart_payment' })
                                .then(function (token) {
                                resolve(token);
                            });
                        }
                    });
                };
                var onSubmit = function (e) {
                    e.preventDefault();
                    if (validate()) {
                        if (recaptchaEnabled)
                            fetchRecaptchaToken().then(function (token) { placeOrder(newsletter, personalMessage, token, getTestOrderOptionValue(testOrderOptionEl)); });
                        else
                            placeOrder(newsletter, personalMessage, "", getTestOrderOptionValue(testOrderOptionEl));
                    }
                };
                var getTestOrderOptionValue = function (container) {
                    var _a;
                    if (!container)
                        return undefined;
                    var radios = eXpress.html.querySelectorAll(container, "[name=TestOrderOption]");
                    return (_a = radios.find(function (x) { return x.checked; })) === null || _a === void 0 ? void 0 : _a.value;
                };
                var validate = function () {
                    var isValid = true;
                    var scrollToEl = null;
                    if (requiredFormInputs && requiredFormInputs.length > 0) {
                        requiredFormInputs.forEach(function (el) {
                            var parent = el.inputEl.parentElement;
                            var errorParagraphEl = eXpress.html.querySelector(parent, ".a-form-input__error-text", true);
                            if (!el.inputEl.checked) {
                                if (!scrollToEl)
                                    scrollToEl = el.inputEl;
                                el.setError(errorParagraphEl.innerHTML);
                                if (eventDisposables && eventDisposables.add) {
                                    eventDisposables.add([
                                        eXpress.html.addEventListener(el.inputEl, 'change', function () { el.clear(false); })
                                    ]);
                                }
                                if (isValid)
                                    isValid = false;
                            }
                        });
                    }
                    if (scrollToEl) {
                        scrollToEl = scrollToEl;
                        scrollToEl.scrollIntoView();
                    }
                    if (isValid)
                        requiredFormInputs.forEach(function (el) { return el.disable(); });
                    return isValid;
                };
                var addHandlers = function () {
                    if (submitButtonEl && eventDisposables && eventDisposables.add) {
                        eventDisposables.add([
                            eXpress.html.addEventListener(submitButtonEl, 'click', onSubmit)
                        ]);
                    }
                };
                var init = function () {
                    newsletter = newsletterEl.checked;
                    personalMessage = personalMessageEl.checked;
                    if (recaptchaEnabled) {
                        if (useEnterprise) {
                            grecaptcha.enterprise.ready(function () {
                                addHandlers();
                            });
                        }
                        else {
                            grecaptcha.ready(function () {
                                addHandlers();
                            });
                        }
                    }
                    else {
                        addHandlers();
                    }
                    if (requiredCheckBoxes && requiredCheckBoxes.length > 0) {
                        requiredCheckBoxes.forEach(function (el) {
                            var parentContainer = eXpress.html.getParentWithClassName(el, "a-form-input");
                            if (parentContainer) {
                                var input = eXpress.components.main.createFormInput(parentContainer);
                                requiredFormInputs.push(input);
                            }
                        });
                    }
                    if (adyenDropInContainerEl) {
                        var createAdyenDropInElement_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, checkout.createAdyenDropIn(adyenDropInContainerEl, {
                                            getPaymentMethods: getPaymentMethods,
                                            validate: validate,
                                            initiatePayment: initiatePayment,
                                            disableStoredPaymentMethod: disableStoredPaymentMethod,
                                            submitAdditionalDetails: submitAdditionalDetails,
                                            placeOfflineOrder: placeOfflineOrder,
                                            newsletterEl: newsletterEl,
                                            personalMessageEl: personalMessageEl,
                                            testOrderOptionEl: testOrderOptionEl,
                                            updateCartHandlingCost: updateCartHandlingCost,
                                            getTestOrderOptionValue: getTestOrderOptionValue,
                                            fetchRecaptchaToken: fetchRecaptchaToken,
                                            recaptchaEnabled: recaptchaEnabled
                                        })];
                                    case 1:
                                        dropIns = _a.sent();
                                        return [2];
                                }
                            });
                        }); };
                        if (recaptchaEnabled) {
                            if (useEnterprise) {
                                grecaptcha.enterprise.ready(function () {
                                    createAdyenDropInElement_1();
                                });
                            }
                            else {
                                grecaptcha.ready(function () {
                                    createAdyenDropInElement_1();
                                });
                            }
                        }
                        else {
                            createAdyenDropInElement_1();
                        }
                    }
                };
                init();
                return {
                    resetAdyenDropIn: function () { return dropIns && dropIns.reset(); },
                    dispose: function () { eventDisposables && eventDisposables.dispose(); dropIns && dropIns.dispose(); },
                };
            }
            checkout.createPlaceOrder = createPlaceOrder;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createCartProductTiles(cartContainerEl, cartProductTilesEl, deps) {
                var refreshMiniBasket = deps.refreshMiniBasket, deleteCartProduct = deps.deleteCartProduct, changeQuantity = deps.changeQuantity, refreshDiscount = deps.refreshDiscount, refreshContinueButton = deps.refreshContinueButton;
                var optionCollapsablesEls = eXpress.html.querySelectorAll(cartProductTilesEl, ".technical-cart-options");
                var cartUpdateTimer;
                var deleteClick = function (el) {
                    var productTile = eXpress.html.getParentWithClassName(el, "technical-cart-1product");
                    if (productTile) {
                        var id = productTile.dataset.cartitemid;
                        var productname = productTile.dataset.productname;
                        var quantityInput = eXpress.html.querySelector(productTile, '.technical-cart-quantity', true);
                        var origCurrentQuantity = parseInt(quantityInput.value, 10) || 0;
                        var currentQuantity_1 = parseInt(quantityInput.value, 10) || 0;
                        if (id) {
                            var isAdditional = productTile.dataset.isadditional === 'true';
                            if (!isAdditional) {
                                var allProductTiles = eXpress.html.querySelectorAll(cartProductTilesEl, ".technical-cart-1product");
                                var additional_1 = 0;
                                var nonAdditionl_1 = 0;
                                allProductTiles.forEach(function (p) {
                                    var isAdditional = p.dataset.isadditional === 'true';
                                    if (isAdditional) {
                                        additional_1++;
                                        var productName = p.dataset.productname;
                                        if (productName) {
                                            var productQuantityInput = eXpress.html.querySelector(p, '.technical-cart-quantity', true);
                                            var productQuantity = parseInt(productQuantityInput.value, 10) || 0;
                                            currentQuantity_1 += productQuantity;
                                        }
                                    }
                                    else
                                        nonAdditionl_1++;
                                });
                                if (additional_1 == 0 || nonAdditionl_1 > 1) {
                                    currentQuantity_1 = origCurrentQuantity;
                                }
                            }
                            deleteCartProduct(id, function (res) {
                                handleGtm(currentQuantity_1, 0, productTile.dataset.gtmdata);
                                refreshBadgeTotal(-currentQuantity_1);
                                if (refreshMiniBasket)
                                    refreshMiniBasket(res.NewMiniBasketHtml);
                                if (refreshDiscount)
                                    refreshDiscount(res.NewDiscountHtml);
                                if (refreshContinueButton)
                                    refreshContinueButton(res.NewContinueButtonHtml);
                                productTile.remove();
                                if (res.EmptyBasketHtml) {
                                    cartContainerEl.innerHTML = res.EmptyBasketHtml;
                                }
                                else if (res.NewProductHtmls) {
                                    res.NewProductHtmls.forEach(function (p) {
                                        var changeTile = eXpress.html.querySelector(cartContainerEl, '.technical-cart-1product[data-cartitemid="' + p.CartItemId + '"]', true);
                                        recreateProductTile(changeTile, p.NewProductHtml);
                                    });
                                }
                            }, productname);
                        }
                    }
                };
                var minusClick = function (el) {
                    minusplusClick(el, -1);
                };
                var plusClick = function (el) {
                    minusplusClick(el, 1);
                };
                var minusplusClick = function (button, change) {
                    var _a;
                    var productTile = eXpress.html.getParentWithClassName(button, "technical-cart-1product");
                    if (!productTile)
                        return;
                    var id = productTile.dataset.cartitemid;
                    if (!id)
                        return;
                    var quantityInput = eXpress.html.querySelector(productTile, '.technical-cart-quantity', true);
                    var lowerQtyBound = 1;
                    var upperQtyBound = parseInt(quantityInput.dataset.max || '999', 10) || 999;
                    var oldQuantity = parseInt(productTile.dataset.quantity || '0', 10);
                    var currentQuantity = parseInt(quantityInput.value, 10) || 0;
                    currentQuantity += change;
                    var outOfBounds = false;
                    if (currentQuantity < lowerQtyBound) {
                        outOfBounds = true;
                        currentQuantity = lowerQtyBound;
                    }
                    if (currentQuantity > upperQtyBound) {
                        outOfBounds = true;
                        currentQuantity = upperQtyBound;
                    }
                    if (outOfBounds)
                        return;
                    if (currentQuantity == 1)
                        button.classList.add('a-button--disabled');
                    else if (button.parentElement)
                        (_a = eXpress.html.querySelector(button.parentElement, '.technical-cart-minus', false)) === null || _a === void 0 ? void 0 : _a.classList.remove('a-button--disabled');
                    refreshBadgeTotal(change);
                    quantityInput.value = currentQuantity.toString();
                    if (cartUpdateTimer) {
                        window.clearTimeout(cartUpdateTimer);
                    }
                    cartUpdateTimer = window.setTimeout(function () {
                        handleGtm(oldQuantity, currentQuantity, productTile.dataset.gtmdata);
                        changeQuantity(id, currentQuantity).then(function (res) {
                            if (refreshMiniBasket)
                                refreshMiniBasket(res.NewMiniBasketHtml);
                            if (refreshDiscount)
                                refreshDiscount(res.NewDiscountHtml);
                            if (res.NewProductHtmls) {
                                res.NewProductHtmls.forEach(function (p) {
                                    var changeTile = eXpress.html.querySelector(cartContainerEl, '.technical-cart-1product[data-cartitemid="' + p.CartItemId + '"]', true);
                                    recreateProductTile(changeTile, p.NewProductHtml);
                                });
                            }
                        });
                    }, 500);
                };
                var handleGtm = function (oldQuanity, newQuantity, gtmData) {
                    if (!gtmData)
                        return;
                    var gtmObject = JSON.parse(gtmData);
                    var changeQuantity = Math.abs(oldQuanity - newQuantity);
                    var product = gtmObject.ecommerce.add.products[0];
                    var productUnitPrice = product.price / product.quantity;
                    product.quantity = changeQuantity;
                    product.priceWOVat = +(product.priceWOVat / oldQuanity * changeQuantity).toFixed(2);
                    product.price = +(productUnitPrice * product.quantity).toFixed(2);
                    if (oldQuanity > newQuantity) {
                        gtmObject.event = 'eec.remove';
                        gtmObject.ecommerce.remove = gtmObject.ecommerce.add;
                        delete gtmObject.ecommerce.add;
                    }
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(gtmObject);
                };
                var recreateProductTile = function (productTile, newHTML) {
                    var reOpenOptions = false;
                    var reFocusQuantity = false;
                    var oldOptionCollapse = eXpress.html.querySelector(productTile, ".technical-cart-options");
                    if (oldOptionCollapse && oldOptionCollapse.classList.contains("is-collapse-open"))
                        reOpenOptions = true;
                    var oldInput = eXpress.html.querySelector(productTile, '.technical-cart-quantity');
                    if (oldInput === document.activeElement)
                        reFocusQuantity = true;
                    var cursorPos = oldInput ? eXpress.utils.doGetCaretPosition(oldInput) : 0;
                    var node = eXpress.html.htmlToElement(newHTML);
                    if (node)
                        productTile.replaceWith(node);
                    var optionCollapse = eXpress.html.querySelector(node, ".technical-cart-options");
                    if (optionCollapse) {
                        var opt = components.main.createCollapsable(optionCollapse, { titleElSelector: '.technical-collapsable-title', scrollIntoViewAfterOpen: true });
                        if (reOpenOptions)
                            opt.open();
                    }
                    if (reFocusQuantity) {
                        var newInput = eXpress.html.querySelector(node, '.technical-cart-quantity');
                        if (newInput) {
                            newInput.focus();
                            eXpress.utils.setCaretPosition(newInput, cursorPos);
                        }
                    }
                };
                var fixQuantity = function (inputEl) {
                    var regex = new RegExp("[^0-9]", 'g');
                    var intValue = parseInt(inputEl.value, 10);
                    var lowerQtyBound = 1;
                    var upperQtyBound = parseInt(inputEl.dataset.max || '999', 10) || 999;
                    if (inputEl.value.match(regex) || isNaN(intValue) || intValue > upperQtyBound || intValue < lowerQtyBound) {
                        var productTile = eXpress.html.getParentWithClassName(inputEl, "technical-cart-1product");
                        if (!productTile)
                            return;
                        var oldQuantity = productTile.dataset.quantity;
                        if (oldQuantity)
                            inputEl.value = oldQuantity;
                    }
                };
                var updateQuantity = function (inputEl) {
                    var productTile = eXpress.html.getParentWithClassName(inputEl, "technical-cart-1product");
                    if (!productTile)
                        return;
                    var id = productTile.dataset.cartitemid;
                    if (!id)
                        return;
                    if (cartUpdateTimer) {
                        window.clearTimeout(cartUpdateTimer);
                    }
                    var oldQuantity = parseInt(productTile.dataset.quantity || '0', 10);
                    var currentQuantity = parseInt(inputEl.value, 10) || 0;
                    var lowerQtyBound = 1;
                    var upperQtyBound = parseInt(inputEl.dataset.max || '999', 10) || 999;
                    if (currentQuantity < lowerQtyBound)
                        return;
                    if (currentQuantity > upperQtyBound)
                        return;
                    if (oldQuantity === currentQuantity)
                        return;
                    cartUpdateTimer = window.setTimeout(function () {
                        handleGtm(oldQuantity, currentQuantity, productTile.dataset.gtmdata);
                        changeQuantity(id, currentQuantity).then(function (res) {
                            refreshBadgeTotal(-oldQuantity + currentQuantity);
                            if (refreshMiniBasket)
                                refreshMiniBasket(res.NewMiniBasketHtml);
                            if (res.NewProductHtmls) {
                                res.NewProductHtmls.forEach(function (p) {
                                    var changeTile = eXpress.html.querySelector(cartContainerEl, '.technical-cart-1product[data-cartitemid="' + p.CartItemId + '"]', true);
                                    recreateProductTile(changeTile, p.NewProductHtml);
                                });
                            }
                        });
                    }, 500);
                };
                var refreshBadgeTotal = function (addToBadge) {
                    var changeBadgeQty = eXpress.html.querySelector(document, '.technical-basket-itemcount', false);
                    if (changeBadgeQty) {
                        var currentBadgeTotal = parseInt(changeBadgeQty.innerText, 10) || 0;
                        var newQuantity = currentBadgeTotal + addToBadge;
                        changeBadgeQty.innerHTML = (newQuantity < 0 ? 0 : newQuantity).toString();
                    }
                };
                var previewClick = function (ev, el) {
                    ev.preventDefault();
                    var productTile = eXpress.html.getParentWithClassName(el, "technical-cart-1product");
                    if (!productTile)
                        return;
                    var editLink = '';
                    var editIcon = eXpress.html.querySelector(productTile, ".icon-pencil", false);
                    if (editIcon && editIcon.parentElement) {
                        var parentEl = editIcon.parentElement;
                        editLink = parentEl.href;
                    }
                    deps.previewPopup(productTile.dataset.cartitemid || '', editLink);
                };
                var clickDispatcher = function (event) {
                    var clickedElement = event.target;
                    if (!clickedElement)
                        return;
                    if (clickedElement.classList.contains('technical-cart-delete'))
                        deleteClick(clickedElement);
                    if (clickedElement.classList.contains('technical-cart-minus'))
                        minusClick(clickedElement);
                    if (clickedElement.classList.contains('technical-cart-plus'))
                        plusClick(clickedElement);
                    if (clickedElement.parentElement && clickedElement.parentElement.classList.contains('technical-preview') || clickedElement.classList.contains('technical-preview'))
                        previewClick(event, clickedElement);
                };
                var keyDispatcher = function (event) {
                    var currentElement = event.target;
                    if (!currentElement)
                        return;
                    var lowerQtyBound = 1;
                    var upperQtyBound = parseInt(currentElement.dataset.max || '999', 10) || 999;
                    if (currentElement.classList.contains('technical-cart-quantity')) {
                        if (event.type === 'keypress')
                            eXpress.utils.isValidNumberAfterKeyPress(event, lowerQtyBound, upperQtyBound);
                        else if (event.type === 'input')
                            updateQuantity(currentElement);
                        else if (event.type === 'focusout')
                            fixQuantity(currentElement);
                    }
                };
                var init = function () {
                    var queryCartItemId = eXpress.utils.getParameter('addedItemId', window.location.href, false);
                    if (queryCartItemId) {
                        var allProductTiles = eXpress.html.querySelectorAll(cartProductTilesEl, ".technical-cart-1product");
                        allProductTiles.forEach(function (p) {
                            var cartItemId = p.dataset.cartitemid;
                            if (cartItemId && queryCartItemId === cartItemId) {
                                var stringGtmData = p.dataset.gtmdata;
                                if (stringGtmData) {
                                    var gtm = JSON.parse(stringGtmData);
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push(gtm);
                                }
                            }
                        });
                    }
                    optionCollapsablesEls.forEach(function (el) {
                        components.main.createCollapsable(el, { scrollIntoViewAfterOpen: true, titleElSelector: '.technical-collapsable-title' });
                    });
                };
                var eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(cartProductTilesEl, 'click', clickDispatcher),
                    eXpress.html.addEventListener(cartProductTilesEl, 'keypress', keyDispatcher),
                    eXpress.html.addEventListener(cartProductTilesEl, 'input', keyDispatcher),
                    eXpress.html.addEventListener(cartProductTilesEl, 'focusout', keyDispatcher)
                ]);
                init();
                return {
                    dispose: function () {
                        eventDisposables.dispose();
                    }
                };
            }
            checkout.createCartProductTiles = createCartProductTiles;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createRemoveConfirmation(containerEl, deps) {
                var onRemoveConfirm = deps.onRemoveConfirm;
                var yesButton = components.main.createButton(eXpress.html.querySelector(containerEl, '.technical-remove-confirmation-yes-button', true), function () { return onRemoveConfirm(true); });
                var noButton = components.main.createButton(eXpress.html.querySelector(containerEl, '.technical-remove-confirmation-no-button', true), function () { return onRemoveConfirm(false); });
                return {
                    dispose: function () {
                        yesButton.dispose();
                        noButton.dispose();
                    }
                };
            }
            checkout.createRemoveConfirmation = createRemoveConfirmation;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createSlideIn(containerEl, deps) {
                var onInit = deps.onInit, onClose = deps.onClose;
                var closeBtnEl = eXpress.html.querySelector(containerEl, ".technical-close", true);
                var onCloseEvent = function () {
                    var hideDays = parseInt(containerEl.dataset.hidedays || "30", 10);
                    containerEl.classList.add("u-hide");
                    if (onClose)
                        onClose();
                    eXpress.utils.writeCookie("showRecSlideIn", "false", hideDays);
                    closeEvent.dispose();
                    containerEl.remove();
                    eXpress.analytics.trackRecommendationCartEvent("Slide-in slider closed");
                };
                var closeEvent = eXpress.html.addEventListener(closeBtnEl, 'click', onCloseEvent);
                if (onInit)
                    onInit();
                return { dispose: closeEvent.dispose };
            }
            checkout.createSlideIn = createSlideIn;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createTrailDialog(dialog, deps) {
                var statuses = deps.statuses, title = deps.title, delivery = deps.delivery, shipping = deps.shipping, error = deps.error;
                var statusContainer = eXpress.html.querySelector(dialog, '.technical-trail-container', true);
                var titleEl = eXpress.html.querySelector(dialog, '.technical-trail-title', true);
                titleEl.innerHTML = title;
                var deliveryEl = eXpress.html.querySelector(dialog, '.technical-trail-delivery', true);
                if (delivery && !error) {
                    deliveryEl.innerHTML = deps.delivery;
                    deliveryEl.classList.remove("u-hide");
                }
                else
                    deliveryEl.classList.add("u-hide");
                var shippingEl = eXpress.html.querySelector(dialog, '.technical-trail-shipping', true);
                if (shipping && !error) {
                    shippingEl.innerHTML = deps.shipping;
                    shippingEl.classList.remove("u-hide");
                    var ttLinks = eXpress.html.querySelectorAll(shippingEl, ".technical-tracktrace");
                    ttLinks.forEach(function (link) { return link.addEventListener('click', function (ev) {
                        eXpress.analytics.trackOrderStatusEvent("TrailDialogTrackTraceClick", { orderNumber: deps.orderNumber, orderStatus: deps.currentStatus, pvc: deps.pvc });
                    }); });
                    var voucherLinks = eXpress.html.querySelectorAll(shippingEl, ".technical-voucher");
                    voucherLinks.forEach(function (link) { return link.addEventListener('click', function (ev) {
                        eXpress.analytics.trackOrderStatusEvent("TrailDialogVoucherDownload", { orderNumber: deps.orderNumber, orderStatus: deps.currentStatus, pvc: deps.pvc });
                    }); });
                }
                else
                    shippingEl.classList.add("u-hide");
                if (error) {
                    var errorEl = eXpress.html.querySelector(statusContainer, '.technical-trail-error', true);
                    errorEl.classList.remove("u-hide");
                }
                else {
                    var statusTemplate_1 = eXpress.html.querySelector(statusContainer, '.technical-trail-template', true);
                    eXpress.html.querySelectorAll(statusContainer, '.technical-trail-block')
                        .forEach(function (block) { return statusContainer.removeChild(block); });
                    var lastActiveIndex_1 = statuses.reduce(function (acc, status, index) { return (status.active ? index : acc); }, -1);
                    var index_1 = 0;
                    statuses.forEach(function (status) {
                        var statusClone = statusTemplate_1.cloneNode(true);
                        statusClone.classList.remove('technical-trail-template');
                        statusClone.classList.remove('u-hide');
                        statusClone.classList.add('technical-trail-block');
                        statusClone.dataset.name = status.name;
                        eXpress.html.querySelector(statusClone, '.technical-trail-status', true).innerHTML = status.status;
                        eXpress.html.querySelector(statusClone, '.technical-trail-description', true).innerHTML = status.description;
                        if (!status.active)
                            statusClone.classList.remove('m-trail__element--completed');
                        if (lastActiveIndex_1 === index_1)
                            statusClone.classList.add('m-trail__element--last-completed');
                        statusContainer.appendChild(statusClone);
                        index_1++;
                    });
                }
                return {};
            }
            checkout.createTrailDialog = createTrailDialog;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
